/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/js/helpers/drag-scroll.js":
/*!***************************************!*\
  !*** ./src/js/helpers/drag-scroll.js ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "attachDragScroll": () => (/* binding */ attachDragScroll)
/* harmony export */ });
/**
 * Mouse drag-to-scroll for a horizontal overflow container (cart upsells, PDP thumbnails).
 * Touch and touchpad already scroll the container natively, so this only kicks in for
 * pointerType 'mouse' — where an overflow container with a hidden scrollbar is otherwise
 * unscrollable. While dragging, CSS scroll-snap is suspended (.is-dragging), otherwise
 * every scrollLeft update would snap right back; on release the track smooth-scrolls to
 * the nearest item to restore the snapped position.
 *
 * - track: the scroll container
 * - itemSelector: the snap targets inside the track (default: its direct children)
 */
var attachDragScroll = function attachDragScroll(track) {
  var itemSelector = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':scope > *';
  var startX = 0;
  var startScrollLeft = 0;
  var dragging = false;
  var dragged = false;
  track.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse' || e.button !== 0) return;
    dragging = true;
    dragged = false;
    startX = e.clientX;
    startScrollLeft = track.scrollLeft;
  });
  track.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var delta = e.clientX - startX; // Dead zone so a sloppy click doesn't turn into a micro-drag.

    if (!dragged && Math.abs(delta) < 4) return;

    if (!dragged) {
      dragged = true;
      track.classList.add('is-dragging');
      track.setPointerCapture(e.pointerId);
    }

    track.scrollLeft = startScrollLeft - delta;
  });

  var endDrag = function endDrag() {
    if (!dragging) return;
    dragging = false;
    if (dragged) snapToNearestItem(track, itemSelector);
  };

  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag); // Native HTML5 drag (product images) hijacks the pointer as soon as the
  // drag starts on an <img> — block it so the track drag wins.

  track.addEventListener('dragstart', function (e) {
    return e.preventDefault();
  }); // A drag must not count as a click on whatever the pointer was released
  // over (card / button) — swallow the click that follows a real drag.

  track.addEventListener('click', function (e) {
    if (!dragged) return;
    dragged = false;
    e.preventDefault();
    e.stopPropagation();
  }, true);
};

var snapToNearestItem = function snapToNearestItem(track, itemSelector) {
  var snapLeft = track.getBoundingClientRect().left + (parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0);
  var nearest = 0;
  var minDistance = Infinity;
  track.querySelectorAll(itemSelector).forEach(function (item) {
    if (!item.clientWidth) return; // hidden items (e.g. variant thumbnails)

    var delta = item.getBoundingClientRect().left - snapLeft;

    if (Math.abs(delta) < minDistance) {
      minDistance = Math.abs(delta);
      nearest = delta;
    }
  });
  track.scrollBy({
    left: nearest,
    behavior: 'smooth'
  }); // Re-enable scroll snapping only after the smooth scroll has settled —
  // re-adding it mid-animation cancels the scroll with a jump.

  setTimeout(function () {
    return track.classList.remove('is-dragging');
  }, 400);
};

/***/ }),

/***/ "./src/js/helpers/format-money.js":
/*!****************************************!*\
  !*** ./src/js/helpers/format-money.js ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "formatMoney": () => (/* binding */ formatMoney)
/* harmony export */ });
var formatMoney = function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
};

/***/ }),

/***/ "./src/js/helpers/scroll-to-element.js":
/*!*********************************************!*\
  !*** ./src/js/helpers/scroll-to-element.js ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "scrollToElement": () => (/* binding */ scrollToElement)
/* harmony export */ });
var scrollToElement = function scrollToElement(selector, offset) {
  var targetElement = document.querySelector('#' + 'shopify-section-' + selector); // header height for sticky navs
  //let headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height').replace('px', '');

  if (targetElement) {
    // offset for sticky headers
    var yOffset = offset ? offset : 0;
    var y = targetElement.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }
};

/***/ }),

/***/ "./src/js/modules/ed-ab-sync.js":
/*!**************************************!*\
  !*** ./src/js/modules/ed-ab-sync.js ***!
  \**************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var EdAbSync = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdAbSync, _HTMLElement);

  var _super = _createSuper(EdAbSync);

  function EdAbSync() {
    var _this;

    _classCallCheck(this, EdAbSync);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "_cartAttributes", {});

    _defineProperty(_assertThisInitialized(_this), "_pendingUpdate", false);

    _defineProperty(_assertThisInitialized(_this), "_queuedAttributes", {});

    _defineProperty(_assertThisInitialized(_this), "_onAssign", null);

    return _this;
  }

  _createClass(EdAbSync, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._cartAttributes = JSON.parse(this.getAttribute('current-cart-attributes') || '{}');

      this._attachListeners();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('ed:ab:assign', this._onAssign);
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this._onAssign = this._handleAssign.bind(this);
      document.addEventListener('ed:ab:assign', this._onAssign);
    }
  }, {
    key: "_handleAssign",
    value: function _handleAssign(e) {
      var _e$detail = e.detail,
          test = _e$detail.test,
          variant = _e$detail.variant;
      if (!test || !variant) return;
      var key = "_ed-ab-".concat(test);
      var isControl = variant === 'A';
      var currentValue = this._cartAttributes[key]; // Variante A: Attribut löschen falls vorhanden
      // Variante B/C/...: Attribut setzen falls nicht bereits korrekt gesetzt

      if (isControl && !(key in this._cartAttributes)) return;
      if (!isControl && currentValue === variant) return;
      this._queuedAttributes[key] = isControl ? '' : variant;

      this._scheduleUpdate();
    } // Batching: mehrere Events im selben Tick → ein einziger /cart/update.js Request

  }, {
    key: "_scheduleUpdate",
    value: function _scheduleUpdate() {
      var _this2 = this;

      if (this._pendingUpdate) return;
      this._pendingUpdate = true;
      queueMicrotask(function () {
        _this2._flushUpdate();
      });
    }
  }, {
    key: "_flushUpdate",
    value: function _flushUpdate() {
      var _this3 = this;

      var attributes = _objectSpread({}, this._queuedAttributes);

      this._queuedAttributes = {};
      this._pendingUpdate = false;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          attributes: attributes
        })
      }).then(function (res) {
        return res.json();
      }).then(function (cart) {
        var _cart$attributes;

        // Lokalen State nach Update synchronisieren
        _this3._cartAttributes = (_cart$attributes = cart.attributes) !== null && _cart$attributes !== void 0 ? _cart$attributes : {};
        console.debug('[ed-ab-sync] cart attributes synced:', _this3._cartAttributes);
      })["catch"](function (err) {
        console.error('[ed-ab-sync] failed to update cart attributes:', err);
      });
    }
  }]);

  return EdAbSync;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-ab-sync', EdAbSync);

/***/ }),

/***/ "./src/js/modules/ed-announcement-countdown.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-announcement-countdown.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdAnnouncementCountdown = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdAnnouncementCountdown, _HTMLElement);

  var _super = _createSuper(EdAnnouncementCountdown);

  function EdAnnouncementCountdown() {
    _classCallCheck(this, EdAnnouncementCountdown);

    return _super.apply(this, arguments);
  }

  _createClass(EdAnnouncementCountdown, [{
    key: "_parseEndTime",
    value: function _parseEndTime(str) {
      // erwartet Format: "DD/MM/YYYY hh:mm:ss"
      if (!str) return null;

      var _str$trim$split = str.trim().split(/\s+/),
          _str$trim$split2 = _slicedToArray(_str$trim$split, 2),
          datePart = _str$trim$split2[0],
          _str$trim$split2$ = _str$trim$split2[1],
          timePart = _str$trim$split2$ === void 0 ? '00:00:00' : _str$trim$split2$;

      var _datePart$split$map = datePart.split('/').map(Number),
          _datePart$split$map2 = _slicedToArray(_datePart$split$map, 3),
          dd = _datePart$split$map2[0],
          mm = _datePart$split$map2[1],
          yyyy = _datePart$split$map2[2];

      var _timePart$split$map = timePart.split(':').map(Number),
          _timePart$split$map2 = _slicedToArray(_timePart$split$map, 3),
          _timePart$split$map2$ = _timePart$split$map2[0],
          hh = _timePart$split$map2$ === void 0 ? 0 : _timePart$split$map2$,
          _timePart$split$map2$2 = _timePart$split$map2[1],
          mi = _timePart$split$map2$2 === void 0 ? 0 : _timePart$split$map2$2,
          _timePart$split$map2$3 = _timePart$split$map2[2],
          ss = _timePart$split$map2$3 === void 0 ? 0 : _timePart$split$map2$3;

      var d = new Date(yyyy, (mm || 1) - 1, dd || 1, hh, mi, ss); // lokal

      return isNaN(d) ? null : d;
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.endTime = this._parseEndTime(this.getAttribute('end-time')); // Date-Objekt

      this._attachSelectors();

      this._attachListeners();

      this.startCountdown();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      clearInterval(this.timer);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.daysWrapContainer = this.querySelector('[data-days-wrap], .days-wrap');
      this.daysValue = this.querySelector('.value[data-days]');
      this.hoursValue = this.querySelector('.value[data-hours]');
      this.minutesValue = this.querySelector('.value[data-minutes]');
      this.secondsValue = this.querySelector('.value[data-seconds]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {}
  }, {
    key: "startCountdown",
    value: function startCountdown() {
      var _this = this;

      this.tick();
      this.timer = setInterval(function () {
        return _this.tick();
      }, 1000);
    }
  }, {
    key: "tick",
    value: function tick() {
      var now = new Date();
      var diff = Math.max(0, Math.floor((this.endTime - now) / 1000));
      var d = Math.floor(diff / 86400);
      var h = Math.floor(diff % 86400 / 3600);
      var m = Math.floor(diff % 3600 / 60);
      var s = diff % 60;
      this.daysWrapContainer.style.display = d > 0 ? '' : 'none';
      this.daysValue.textContent = d.toString().padStart(2, '0');
      this.hoursValue.textContent = h.toString().padStart(2, '0');
      this.minutesValue.textContent = m.toString().padStart(2, '0');
      this.secondsValue.textContent = s.toString().padStart(2, '0');
    }
  }]);

  return EdAnnouncementCountdown;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-announcement-countdown')) {
  customElements.define('ed-announcement-countdown', EdAnnouncementCountdown);
}

/***/ }),

/***/ "./src/js/modules/ed-blog-filter.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-blog-filter.js ***!
  \******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdBlogFilter = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdBlogFilter, _HTMLElement);

  var _super = _createSuper(EdBlogFilter);

  function EdBlogFilter() {
    _classCallCheck(this, EdBlogFilter);

    return _super.apply(this, arguments);
  }

  _createClass(EdBlogFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      requestAnimationFrame(this._checkOverflowingTags.bind(this));

      this._setActiveTagClass();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.tagButtons = _toConsumableArray(this.querySelectorAll('.ed-tag-button')).filter(function (btn) {
        return !btn.classList.contains('load-more-button');
      });
      this.moreButton = this.querySelector('.load-more-button');
      this.dropdownContent = this.querySelector('.dropdown-content');
      this.dropdown = this.querySelector('.blog-filter-mobile');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.moreButton.addEventListener('click', this._toggleDropdown.bind(this));

      if (this.dropdown) {
        this.dropdown.addEventListener('change', this._handleDropdownChange.bind(this));
      }
    }
  }, {
    key: "_handleDropdownChange",
    value: function _handleDropdownChange(event) {
      window.location.href = event.target.value;
    }
  }, {
    key: "_toggleDropdown",
    value: function _toggleDropdown(event) {
      this.dropdownContent.classList.toggle('show-dropdown');
    }
  }, {
    key: "_checkOverflowingTags",
    value: function _checkOverflowingTags() {
      var _this = this;

      var firstButtonOffset = this.tagButtons[0].offsetTop;
      var lastVisibleTag = null;
      var firstOverflowDetected = false;
      this.tagButtons.forEach(function (button) {
        if (button.offsetTop > firstButtonOffset && !firstOverflowDetected) {
          firstOverflowDetected = true;

          if (lastVisibleTag) {
            lastVisibleTag.classList.add('is-overflowing');
            _this.moreButton.style.display = 'inline-flex';
            _this.moreButton.style.alignItems = 'center';

            _this.dropdownContent.appendChild(lastVisibleTag);
          }
        }

        if (firstOverflowDetected) {
          button.classList.add('is-overflowing');

          _this.dropdownContent.appendChild(button);
        } else {
          lastVisibleTag = button;
        }
      });

      if (document.readyState !== 'loading') {
        var blog_filter = document.getElementById('blog-filter');
        blog_filter.style.visibility = 'visible';
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          var blog_filter = document.getElementById('blog-filter');
          blog_filter.style.visibility = 'visible';
        });
      }
    }
  }, {
    key: "_setActiveTagClass",
    value: function _setActiveTagClass() {
      var _this2 = this;

      var currentPath = window.location.pathname;
      var loadMoreBtn = document.getElementsByClassName('load-more-button')[0];
      this.tagButtons.forEach(function (button) {
        if (button.getAttribute('href') === currentPath) {
          button.classList.add('ed-active-tag'); // Check if the selected tag is inside the dropdown

          if (button.offsetTop > _this2.tagButtons[0].offsetTop) {
            loadMoreBtn.classList.add('ed-active-tag');
          } // Using setTimeout here because the is-overflowing class gets added only after this if statement


          setTimeout(function () {
            if (button.classList.contains('is-overflowing')) {
              loadMoreBtn.classList.add('ed-active-tag');
              button.insertAdjacentHTML('beforeend', "\n                            <svg class=\"icon icon-checkmark\" aria-hidden=\"true\" focusable=\"false\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\" fill=\"#000\" width=\"13\" height=\"13\" style=\"margin-left: 5px\">\n                                <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z\"/>\n                            </svg>\n                        ");
            }
          });
        } else {
          button.classList.remove('ed-active-tag');
          var checkmark = button.querySelector('.icon-checkmark');

          if (checkmark) {
            checkmark.remove();
          }
        }
      });
    }
  }]);

  return EdBlogFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-blog-filter')) {
  customElements.define('ed-blog-filter', EdBlogFilter);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-subscription-group.js":
/*!******************************************************!*\
  !*** ./src/js/modules/ed-cart-subscription-group.js ***!
  \******************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * <ed-cart-subscription-group> — subscription line items grouped at the top of
 * the cart drawer under an openable info header.
 *
 * Markup: snippets/ed-cart-subscription-group.liquid
 *
 * The cart drawer swaps its whole innerHTML on every cart change (add, quantity,
 * remove), which recreates this element. The open/closed state therefore lives
 * at module level, so an info panel the customer opened stays open across those
 * re-renders instead of snapping shut after every quantity click.
 */
var isOpen = false;

var EdCartSubscriptionGroup = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartSubscriptionGroup, _HTMLElement);

  var _super = _createSuper(EdCartSubscriptionGroup);

  function EdCartSubscriptionGroup() {
    _classCallCheck(this, EdCartSubscriptionGroup);

    return _super.apply(this, arguments);
  }

  _createClass(EdCartSubscriptionGroup, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors(); // No info text configured → static heading only, nothing to toggle.


      if (!this.toggle || !this.panel) return;

      this._attachListeners();

      this._render();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.toggle = this.querySelector('[data-subscription-toggle]');
      this.panel = this.querySelector('[data-subscription-info]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.toggle.addEventListener('click', this.handleToggle.bind(this));
    }
  }, {
    key: "handleToggle",
    value: function handleToggle() {
      isOpen = !isOpen;

      this._render();
    }
  }, {
    key: "_render",
    value: function _render() {
      this.classList.toggle('is-open', isOpen);
      this.toggle.setAttribute('aria-expanded', String(isOpen));
      this.panel.hidden = !isOpen;
    }
  }]);

  return EdCartSubscriptionGroup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-cart-subscription-group')) {
  customElements.define('ed-cart-subscription-group', EdCartSubscriptionGroup);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-subscription-plan.js":
/*!*****************************************************!*\
  !*** ./src/js/modules/ed-cart-subscription-plan.js ***!
  \*****************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * <ed-cart-subscription-plan> — change the delivery interval of a subscription
 * line item directly in the cart drawer, or switch the line back to a one-time
 * purchase.
 *
 * Markup: snippets/ed-cart-subscription-plan.liquid — the badge is the trigger
 * of an <ed-dropdown> (src/js/modules/ed-dropdown.js) whose native <select>
 * holds the variant's selling plans; an empty value means "one-time purchase".
 * This element only listens to the select's `change`, so the picker UI can
 * change without touching the cart logic.
 *
 * The update goes through the drawer's own CartItems.updateQuantity()
 * (assets/cart.js), which takes an optional extra payload — so request, loading
 * state, drawer re-render, live region and the gift-system event behave exactly
 * like a quantity change. Nothing here calls the cart API directly.
 * `selling_plan: null` removes the plan from the line (one-time purchase).
 *
 * On success the drawer swaps its innerHTML and this element is recreated;
 * `pendingFocusLine` carries the focus over to the new instance so keyboard
 * users stay on the badge they just changed. After a switch to one-time
 * purchase there is no badge anymore, so the focus lands on the line's quantity
 * input instead. If the element is still connected once the request has
 * settled, nothing re-rendered — the update failed and the badge reverts.
 */
var pendingFocusLine = null;
var lastInputWasKeyboard = false;
document.addEventListener('keydown', function () {
  lastInputWasKeyboard = true;
}, true);
document.addEventListener('pointerdown', function () {
  lastInputWasKeyboard = false;
}, true);

var EdCartSubscriptionPlan = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartSubscriptionPlan, _HTMLElement);

  var _super = _createSuper(EdCartSubscriptionPlan);

  function EdCartSubscriptionPlan() {
    _classCallCheck(this, EdCartSubscriptionPlan);

    return _super.apply(this, arguments);
  }

  _createClass(EdCartSubscriptionPlan, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      if (!this.select || !this.label || !this.cartItems) return;

      this._attachListeners();

      if (pendingFocusLine === this.dataset.line) {
        pendingFocusLine = null;
        if (lastInputWasKeyboard && this.trigger) this.trigger.focus({
          preventScroll: true
        });
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.select = this.querySelector('[data-subscription-plan-select]');
      this.label = this.querySelector('[data-subscription-plan-label]');
      this.trigger = this.querySelector('[data-dropdown-trigger]');
      this.cartItems = this.closest('cart-drawer-items');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.select.addEventListener('change', this.handleChange.bind(this));
    }
  }, {
    key: "handleChange",
    value: function handleChange(event) {
      var _this = this;

      // <cart-drawer-items> treats every bubbling `change` as a quantity change.
      event.stopPropagation();
      var plan = this.select.value;
      if (plan === this.dataset.currentPlan) return;

      this._setUpdating(true);

      var line = this.dataset.line;
      pendingFocusLine = line;
      var request = this.cartItems.updateQuantity(line, this.dataset.quantity, null, {
        selling_plan: plan || null
      });

      if (request && typeof request.then === 'function') {
        request.then(function () {
          if (_this.isConnected) {
            _this._revert();

            return;
          } // Re-rendered without a badge for this line (now a one-time
          // purchase): park the focus on the line's quantity input.


          if (pendingFocusLine === line) {
            pendingFocusLine = null;
            var input = document.querySelector("#CartDrawer-Item-".concat(line, " .quantity__input"));
            if (lastInputWasKeyboard && input) input.focus({
              preventScroll: true
            });
          }
        });
      }
    }
  }, {
    key: "_setUpdating",
    value: function _setUpdating(updating) {
      this.classList.toggle('is-updating', updating);
      this.select.disabled = updating;
      this.setAttribute('aria-busy', String(updating)); // Show the chosen option right away; _revert() takes it back on failure.

      if (updating) this._syncLabel();
    }
  }, {
    key: "_syncLabel",
    value: function _syncLabel() {
      var option = this.select.selectedOptions[0];
      if (option) this.label.textContent = option.text;
    }
  }, {
    key: "_revert",
    value: function _revert() {
      pendingFocusLine = null;
      this.select.value = this.dataset.currentPlan;

      this._syncLabel();

      this._setUpdating(false);

      var errors = document.getElementById('CartDrawer-CartErrors');
      if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
    }
  }]);

  return EdCartSubscriptionPlan;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-cart-subscription-plan')) {
  customElements.define('ed-cart-subscription-plan', EdCartSubscriptionPlan);
}

/***/ }),

/***/ "./src/js/modules/ed-cart-upsells.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-cart-upsells.js ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_drag_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/drag-scroll */ "./src/js/helpers/drag-scroll.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * <ed-cart-upsells> — Upsell recommendations inside the cart drawer.
 *
 * The element starts life as an empty placeholder that only carries a `data-url`.
 * When it scrolls into view it lazy-loads its markup from that URL and wires up
 * the add-to-cart buttons.
 *
 * The product SOURCE is intentionally decoupled from this component: the JS only
 * fetches `data-url` and expects the response to contain an <ed-cart-upsells>
 * element with ready-to-render markup. Today `data-url` points at Shopify's
 * product recommendations route (seeded with the first valid product in the cart
 * — see snippets/ed-cart-upsells.liquid). Swapping that URL for a metafield-driven
 * section later requires no changes to this file.
 *
 * Re-render behaviour: adding a product re-renders the whole cart drawer, which
 * recreates this placeholder. To avoid a full reload flash we keep a module-level
 * cache of the already-rendered markup keyed by `data-url`: the recreated element
 * restores instantly from cache instead of re-fetching. On add we fade the chosen
 * card out and drop it from both the DOM and the cache, so the restored block just
 * misses that one card.
 */

var RENDER_CACHE = new Map();
/**
 * A/B/C test (DER-483) — which variant gets added on click:
 *   'a' → no change (server-rendered default variant)
 *   'b' → respect the has_travel_size metafield (travel-size variant)
 *   'c' → always the first variant
 *
 * The active group is signalled by the external A/B tool the same way as every
 * other DER test: it dispatches `ed-ab-der-483-b` / `ed-ab-der-483-c`, which the
 * ed-ab-der-483 snippet turns into an `html.ed-ab-der-483-{b,c}` bucket class. We
 * read that class (so a group set before this element renders still applies) and
 * also listen for the events (so a group set afterwards re-applies live). Absent
 * either, the mode is 'a' — the server default — so the control needs no JS.
 */

var forcedMode = null;

function resolveMode() {
  if (forcedMode) return forcedMode;
  var cl = document.documentElement.classList;
  if (cl.contains('ed-ab-der-483-c')) return 'c';
  if (cl.contains('ed-ab-der-483-b')) return 'b';
  return 'a';
}

function applyModeToAll() {
  document.querySelectorAll('ed-cart-upsells').forEach(function (el) {
    if (typeof el._applyVariantMode === 'function') el._applyVariantMode();
  });
}

['a', 'b', 'c'].forEach(function (mode) {
  document.addEventListener("ed-ab-der-483-".concat(mode), function () {
    forcedMode = mode;
    applyModeToAll();
  });
});

var EdCartUpsells = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCartUpsells, _HTMLElement);

  var _super = _createSuper(EdCartUpsells);

  function EdCartUpsells() {
    _classCallCheck(this, EdCartUpsells);

    return _super.apply(this, arguments);
  }

  _createClass(EdCartUpsells, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      var cached = this.dataset.url ? RENDER_CACHE.get(this.dataset.url) : null;

      if (cached) {
        // The drawer just re-rendered — restore seamlessly, no fetch, no fade.
        this.innerHTML = cached;

        this._attachListeners();
      } else if (this.dataset.url && !this._hasContent()) {
        this._lazyLoad();
      } else {
        this._attachListeners();
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cart = document.querySelector('cart-drawer');
    }
  }, {
    key: "_hasContent",
    value: function _hasContent() {
      return !!this.querySelector('[data-upsell-item]');
    }
  }, {
    key: "_lazyLoad",
    value: function _lazyLoad() {
      var _this = this;

      if (this._loaded) return;
      this._loaded = true;
      var observer = new IntersectionObserver(function (entries, obs) {
        if (!entries[0].isIntersecting) return;
        obs.disconnect();

        _this._fetchUpsells();
      }, {
        rootMargin: '0px 0px 200px 0px'
      });
      observer.observe(this);
    }
  }, {
    key: "_fetchUpsells",
    value: function _fetchUpsells() {
      var _this2 = this;

      fetch(this.dataset.url).then(function (response) {
        return response.text();
      }).then(function (text) {
        var rendered = new DOMParser().parseFromString(text, 'text/html').querySelector('ed-cart-upsells');

        if (!rendered || !rendered.innerHTML.trim().length) {
          _this2._removeWidget();

          return;
        }

        _this2.innerHTML = rendered.innerHTML;
        RENDER_CACHE.set(_this2.dataset.url, _this2.innerHTML);

        _this2._attachListeners();

        _this2._fadeIn();
      })["catch"](function (e) {
        console.error('[ed-cart-upsells]', e);

        _this2._removeWidget();
      });
    } // No recommendations to show: drop the whole widget, including the accordion
    // shell (toggler + heading) that lives around this element in the drawer — so
    // an empty response never leaves a dangling header or toggler behind.

  }, {
    key: "_removeWidget",
    value: function _removeWidget() {
      (this.closest('.ed-cart-upsells-accordion') || this).remove();
    }
  }, {
    key: "_fadeIn",
    value: function _fadeIn() {
      var _this3 = this;

      this.classList.add('is-entering'); // Two frames so the initial opacity:0 is painted before we transition to 1.

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          return _this3.classList.remove('is-entering');
        });
      });
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this4 = this;

      this.querySelectorAll('[data-upsell-add]').forEach(function (button) {
        button.addEventListener('click', function (e) {
          return _this4._handleAddToCart(e);
        });
      });

      this._attachDragScroll();

      this._applyVariantMode();
    } // Mouse drag-to-scroll for the card track, see helpers/drag-scroll.js

  }, {
    key: "_attachDragScroll",
    value: function _attachDragScroll() {
      var track = this.querySelector('[data-upsell-track]');
      if (!track) return;
      (0,_helpers_drag_scroll__WEBPACK_IMPORTED_MODULE_0__.attachDragScroll)(track, '[data-upsell-item]');
    }
    /**
     * Point each card at the variant its A/B/C group should add, and show that
     * group's price block. A no-op for the control ('a') since the server already
     * renders it. Idempotent, so it can run on every render and on every event.
     */

  }, {
    key: "_applyVariantMode",
    value: function _applyVariantMode() {
      var mode = resolveMode();
      this.querySelectorAll('[data-upsell-item]').forEach(function (item) {
        var variantId = item.dataset["variant".concat(mode.toUpperCase())] || item.dataset.variantA;
        var input = item.querySelector('[name="id"]');
        if (input && variantId) input.value = variantId;
        var blocks = item.querySelectorAll('[data-upsell-price]');
        if (!blocks.length) return; // Fall back to the 'a' block when this mode has no distinct price.

        var target = item.querySelector("[data-upsell-price=\"".concat(mode, "\"]")) ? mode : 'a';
        blocks.forEach(function (block) {
          block.hidden = block.dataset.upsellPrice !== target;
        });
      });
    }
  }, {
    key: "_handleAddToCart",
    value: function _handleAddToCart(e) {
      e.preventDefault();
      var button = e.currentTarget;
      var form = button.closest('form');
      if (!form || button.disabled) return;
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');

      this._addToCart(form, button);
    }
  }, {
    key: "_addToCart",
    value: function _addToCart(form, button) {
      var _this5 = this;

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var formData = new FormData(form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
          return section.id;
        }));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
      fetch("".concat(routes.cart_add_url), config).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.status) {
          // Shopify returns an error object carrying a `status` on failure.
          console.error('[ed-cart-upsells]', response.description || response.message);
          button.disabled = false;
          button.removeAttribute('aria-disabled');
          return;
        }

        _this5._removeCard(button.closest('[data-upsell-item]'), function () {
          // Note: intentionally no 'ed:good-choice-banner:toggle' here —
          // the "Gute Wahl" banner should not show on upsell adds.
          document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
            detail: {
              isCustomAtcButton: true
            }
          }));

          if (_this5.cart) {
            _this5.cart.renderContents(response);

            if (_this5.cart.classList.contains('is-empty')) {
              _this5.cart.classList.remove('is-empty');
            }
          }
        });
      })["catch"](function (e) {
        console.error('[ed-cart-upsells]', e);
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      });
    }
    /**
     * Fade the just-added card out, drop it from the DOM + cache, then run `done`
     * (which re-renders the cart). Because the cache no longer holds that card, the
     * placeholder recreated by the re-render restores without it — so the block stays
     * put and only the chosen product disappears.
     */

  }, {
    key: "_removeCard",
    value: function _removeCard(card, done) {
      var _this6 = this;

      if (!card) {
        done();
        return;
      }

      var finish = function finish() {
        card.removeEventListener('transitionend', finish);
        clearTimeout(fallback);
        card.remove();

        if (_this6.dataset.url) {
          if (_this6.querySelector('[data-upsell-item]')) {
            RENDER_CACHE.set(_this6.dataset.url, _this6.innerHTML);
          } else {
            RENDER_CACHE["delete"](_this6.dataset.url);
          }
        }

        done();
      };

      var fallback = setTimeout(finish, 350);
      card.addEventListener('transitionend', finish);
      card.classList.add('is-removing');
    }
  }]);

  return EdCartUpsells;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-cart-upsells')) {
  customElements.define('ed-cart-upsells', EdCartUpsells);
}
/**
 * <ed-cart-upsells-toggler> — the accordion header rendered from the collapse
 * threshold onward (see snippets/ed-cart-upsells.liquid). A click flips `open`
 * on itself and `visible` on the sibling panel. The panel starts hidden, so
 * <ed-cart-upsells> inside it only lazy-loads once the customer opens the
 * accordion.
 */


var EdCartUpsellsToggler = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdCartUpsellsToggler, _HTMLElement2);

  var _super2 = _createSuper(EdCartUpsellsToggler);

  function EdCartUpsellsToggler() {
    _classCallCheck(this, EdCartUpsellsToggler);

    return _super2.apply(this, arguments);
  }

  _createClass(EdCartUpsellsToggler, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this7 = this;

      this.addEventListener('click', function () {
        return _this7._toggle();
      });
    }
  }, {
    key: "_toggle",
    value: function _toggle() {
      this.classList.toggle('open');
      var panel = this.nextElementSibling;
      if (panel) panel.classList.toggle('visible');
    }
  }]);

  return EdCartUpsellsToggler;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-cart-upsells-toggler')) {
  customElements.define('ed-cart-upsells-toggler', EdCartUpsellsToggler);
}

/***/ }),

/***/ "./src/js/modules/ed-cross-sell.js":
/*!*****************************************!*\
  !*** ./src/js/modules/ed-cross-sell.js ***!
  \*****************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdCrossSell = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdCrossSell, _HTMLElement);

  var _super = _createSuper(EdCrossSell);

  function EdCrossSell() {
    _classCallCheck(this, EdCrossSell);

    return _super.apply(this, arguments);
  }

  _createClass(EdCrossSell, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._loadRecommendations();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.atcButton = this.querySelector('.product-form__submit');
      this.cart = document.querySelector('cart-drawer');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.buttons = this.querySelectorAll('.product-form__submit');
      this.buttons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          return _this._handleAddToCart(e);
        });
      });

      this._bindSliderDots();
    }
  }, {
    key: "_handleAddToCart",
    value: function _handleAddToCart(e) {
      if (e.currentTarget !== e.target && !e.target.closest('button')) return;
      e.preventDefault();
      var button = e.currentTarget;
      var form = button.closest('form');
      if (!form) return;
      button.disabled = true;
      this.addToCart(form, button);
    }
  }, {
    key: "addToCart",
    value: function addToCart(form, button) {
      var _this2 = this;

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var formData = new FormData(form);
      formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
        return section.id;
      }));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
      this.cart.setActiveElement(document.activeElement);
      fetch("".concat(routes.cart_add_url), config).then(function (response) {
        return response.json();
      }).then(function (response) {
        document.dispatchEvent(new CustomEvent('ed:good-choice-banner:toggle'));
        document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
          detail: {
            isCustomAtcButton: true
          }
        }));

        _this2.cart.renderContents(response);

        var variantId = form.querySelector('input[name="id"]').value;

        var slide = _this2.querySelector(".ed-cross-sell__slide[data-variant-id=\"".concat(variantId, "\"]"));

        if (slide) slide.classList.add('hidden');

        _this2._removeCorrespondingDot(slide);

        _this2._checkDotsAndHideIfNeeded();
      })["catch"](function (e) {
        console.error(e);
      })["finally"](function () {
        button.disabled = false;
        button.removeAttribute('aria-disabled');
        if (_this2.cart && _this2.cart.classList.contains('is-empty')) _this2.cart.classList.remove('is-empty');
      });
    }
  }, {
    key: "_removeCorrespondingDot",
    value: function _removeCorrespondingDot(slide) {
      this.slides = Array.from(this.querySelectorAll('.ed-cross-sell__slide')).filter(function (slide) {
        return !slide.classList.contains('hidden');
      });
      this.dots = Array.from(this.querySelectorAll('.slider-counter__link--dots'));
      var allSlides = Array.from(this.querySelectorAll('.ed-cross-sell__slide'));
      var idx = allSlides.indexOf(slide);

      if (idx !== -1 && this.dots[idx]) {
        this.dots[idx].remove();
      }

      var firstVisible = this.slides[0];

      if (this.slider && firstVisible) {
        this.slider.scrollTo({
          left: firstVisible.offsetLeft - this.slider.offsetLeft,
          behavior: 'smooth'
        });
      }

      this._highlightActiveDot();
    }
  }, {
    key: "_checkDotsAndHideIfNeeded",
    value: function _checkDotsAndHideIfNeeded() {
      this.slides = Array.from(this.querySelectorAll('.ed-cross-sell__slide')).filter(function (slide) {
        return !slide.classList.contains('hidden');
      });
      this.dots = Array.from(this.querySelectorAll('.slider-counter__link--dots'));
      var dotsContainer = this.querySelector('.slider-counter');

      if (this.slides.length <= 1 && dotsContainer) {
        dotsContainer.classList.add('hidden');
      } else if (dotsContainer) {
        dotsContainer.classList.remove('hidden');
      }

      if (this.slides.length === 0) {
        this.classList.add('hidden');
      }
    }
  }, {
    key: "_loadRecommendations",
    value: function _loadRecommendations() {
      var _this3 = this;

      if (this.recommendationsLoaded) return;
      this.recommendationsLoaded = true;

      var handleIntersection = function handleIntersection(entries, observer) {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(_this3);
        var count = _this3.dataset.productCount || 3;
        var url = new URL(_this3.dataset.url, window.location.origin);
        url.searchParams.set('limit', count);
        fetch(url).then(function (response) {
          return response.text();
        }).then(function (text) {
          var html = document.createElement('div');
          html.innerHTML = text;
          var recommendations = html.querySelector('ed-cross-sell');

          if (recommendations && recommendations.innerHTML.trim().length) {
            _this3.innerHTML = recommendations.innerHTML;

            _this3._attachListeners();
          }
        })["catch"](function (e) {
          console.error(e);
        });
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: '0px 0px 200px 0px'
      }).observe(this);
    }
  }, {
    key: "_bindSliderDots",
    value: function _bindSliderDots() {
      var _this4 = this;

      this.slider = this.querySelector('ul.grid');
      if (!this.slider) return;
      this.slides = this.slider.querySelectorAll('.ed-cross-sell__slide');
      this.dots = this.querySelectorAll('.slider-counter__link--dots');
      if (!this.dots.length || !this.slides.length) return;
      this.dots.forEach(function (dot, idx) {
        dot.addEventListener('click', function () {
          _this4._scrollToSlide(idx);
        });
      });
      this.slider.addEventListener('scroll', function () {
        return _this4._highlightActiveDot();
      }, {
        passive: true
      });

      this._highlightActiveDot();
    }
  }, {
    key: "_scrollToSlide",
    value: function _scrollToSlide(idx) {
      this.slides = Array.from(this.querySelectorAll('.ed-cross-sell__slide')).filter(function (slide) {
        return !slide.classList.contains('hidden');
      });
      if (!this.slides[idx]) return;
      var left = this.slides[idx].offsetLeft - this.slider.offsetLeft;
      this.slider.scrollTo({
        left: left,
        behavior: 'smooth'
      });
    }
  }, {
    key: "_highlightActiveDot",
    value: function _highlightActiveDot() {
      this.slides = Array.from(this.querySelectorAll('.ed-cross-sell__slide')).filter(function (slide) {
        return !slide.classList.contains('hidden');
      });
      this.dots = Array.from(this.querySelectorAll('.slider-counter__link--dots'));
      var activeIdx = 0;
      var sliderScroll = this.slider ? this.slider.scrollLeft : 0;
      this.slides.forEach(function (slide, idx) {
        if (sliderScroll >= slide.offsetLeft - slide.offsetWidth / 2) {
          activeIdx = idx;
        }
      });
      this.dots.forEach(function (dot, idx) {
        dot.classList.toggle('slider-counter__link--active', idx === activeIdx);
      });
    }
  }]);

  return EdCrossSell;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-cross-sell')) {
  customElements.define('ed-cross-sell', EdCrossSell);
}

/***/ }),

/***/ "./src/js/modules/ed-discount-collection.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-discount-collection.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


var DISCOUNT_STORAGE_KEY = 'edCollectionDiscountState';

var EdDiscountCollection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdDiscountCollection, _HTMLElement);

  var _super = _createSuper(EdDiscountCollection);

  function EdDiscountCollection() {
    _classCallCheck(this, EdDiscountCollection);

    return _super.apply(this, arguments);
  }

  _createClass(EdDiscountCollection, [{
    key: "discountCode",
    get: function get() {
      return this.getAttribute('discount-code');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners(); // disable feature/logic


      if (this.hasAttribute('clear-localstorage')) {
        this.clearDiscountStorage();
        return;
      }

      if (this.getAttribute('collection') && this.discountCode) {
        this.onCollectionLoad();
      } else {
        this.restoreDiscountState();
      }

      this.showDiscountPrices();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.variantDiscounts = this.querySelector('#variant-discounts-json');

      if (this.variantDiscounts) {
        this.variantDiscountsJson = JSON.parse(this.variantDiscounts.textContent.trim());
      }

      this.discountAnnouncementBar = document.querySelector('#shopify-section-discount-announcement-bar');
      this.rechargeWidget = document.querySelector('ed-recharge-widget');
      this.stickyAddToCartBar = document.querySelector('#sticky-add-to-cart-bar');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('variant:changed', this.showDiscountPrices.bind(this));
    }
  }, {
    key: "showDiscountPrices",
    value: function showDiscountPrices(e) {
      var _e$detail, _e$detail$newVariant, _this$discountAnnounc2;

      if (!document.body.classList.contains('ed-dc-cl-enabled')) {
        var _this$discountAnnounc;

        (_this$discountAnnounc = this.discountAnnouncementBar) === null || _this$discountAnnounc === void 0 ? void 0 : _this$discountAnnounc.classList.add('discount-inactive');
        return;
      } // PDP: Price adjustments


      if (this.getAttribute('product') && this.getAttribute('product-has-discount')) {
        var productInfoWrapper = document.querySelector('.product__info-wrapper');
        productInfoWrapper.classList.add('ed-dc-found');
      }

      var variantId = e && e.detail && ((_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : (_e$detail$newVariant = _e$detail.newVariant) === null || _e$detail$newVariant === void 0 ? void 0 : _e$detail$newVariant.id); // PDP: Show Recharge Widget Prices

      if (this.getAttribute('product') && this.rechargeWidget && this.getAttribute('product-has-discount')) {
        if (variantId) {
          this.updateRechargeWidgetPrice(variantId);
        } else if (!e) {
          this.updateRechargeWidgetPrice(this.getAttribute('initial-variant'));
        }
      } // PDP: adjust sticky bar prices


      if (this.getAttribute('product') && this.stickyAddToCartBar && this.getAttribute('product-has-discount')) {
        if (variantId) {
          this.updateStickyAtcBanner(variantId);
        } else if (!e) {
          this.updateStickyAtcBanner(this.getAttribute('initial-variant'));
        }
      } // CP / Global: show product badges


      this.exclusiveProductItemBadges = document.querySelectorAll('[data-discount-exclusive]');
      this.exclusiveProductItemBadges.forEach(function (badge) {
        badge.removeAttribute('data-discount-exclusive'); // todo: body.ed-dc-cl-enabled .product-badge[data-discount-exclusive] {   display: flex !important; }
      });

      if (this.getAttribute('collection')) {
        var quickAtcWrapper = document.querySelectorAll('ed-product-item-atc');
        quickAtcWrapper.forEach(function (item) {
          item.preSelectDiscountedProduct();
        });
      } // Global: Show Discount Announcement Bar


      (_this$discountAnnounc2 = this.discountAnnouncementBar) === null || _this$discountAnnounc2 === void 0 ? void 0 : _this$discountAnnounc2.classList.add('discount-active');
    }
  }, {
    key: "updateRechargeWidgetPrice",
    value: function updateRechargeWidgetPrice(variantId) {
      var _this = this;

      var discountedPrice = this.variantDiscountsJson[variantId] || this.variantDiscountsJson[String(variantId)];
      if (!discountedPrice) return;
      setTimeout(function () {
        _this.oneTimePrice = _this.rechargeWidget.querySelector('.one-time-option-price');

        if (_this.oneTimePrice) {
          _this.oneTimePrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(discountedPrice, window.edGiftSystemSettings.moneyFormat);
        }

        _this.subscriptionPrice = _this.rechargeWidget.querySelector('[data-subscription-price]');

        if (_this.subscriptionPrice) {
          _this.subscriptionPrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(discountedPrice, window.edGiftSystemSettings.moneyFormat);
        }
      }, 50);
    }
  }, {
    key: "updateStickyAtcBanner",
    value: function updateStickyAtcBanner(variantId) {
      var _this2 = this;

      var discountedPrice = this.variantDiscountsJson[variantId] || this.variantDiscountsJson[String(variantId)];
      if (!discountedPrice) return;
      setTimeout(function () {
        _this2.stickyAddToCartBarPrice = _this2.stickyAddToCartBar.querySelector('.price-container');
        _this2.stickyAddToCartBarPrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(discountedPrice, window.edGiftSystemSettings.moneyFormat);
      }, 50);
    }
  }, {
    key: "onCollectionLoad",
    value: function () {
      var _onCollectionLoad = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var result, hasCode;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.applyDiscount(this.discountCode);

              case 2:
                result = _context.sent;
                hasCode = Array.isArray(result.discount_codes) && result.discount_codes.some(function (d) {
                  return d.code === _this3.discountCode;
                });

                if (hasCode) {
                  this.onDiscountApplied();
                  this.saveDiscountState({
                    code: this.discountCode,
                    presentInCart: hasCode,
                    updatedAt: Date.now()
                  });
                } else {
                  console.log("Rabattcode NICHT im Ergebnis gefunden");
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCollectionLoad() {
        return _onCollectionLoad.apply(this, arguments);
      }

      return onCollectionLoad;
    }()
  }, {
    key: "applyDiscount",
    value: function () {
      var _applyDiscount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(code) {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    "Content-Type": "application/json"
                  },
                  body: JSON.stringify({
                    discount: code
                  })
                });

              case 2:
                res = _context2.sent;
                _context2.next = 5;
                return res.json();

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function applyDiscount(_x) {
        return _applyDiscount.apply(this, arguments);
      }

      return applyDiscount;
    }()
  }, {
    key: "onDiscountApplied",
    value: function onDiscountApplied() {
      document.body.classList.add('ed-dc-cl-enabled');
      this.showDiscountPrices();
    }
    /** state management **/

  }, {
    key: "restoreDiscountState",
    value: function restoreDiscountState() {
      var state = this.getSavedDiscountState();
      if (!state) return;

      if (state.code) {
        this.onDiscountApplied();
      }
    }
  }, {
    key: "getSavedDiscountState",
    value: function getSavedDiscountState() {
      try {
        var raw = localStorage.getItem(DISCOUNT_STORAGE_KEY);
        if (!raw) return null;
        return JSON.parse(raw);
      } catch (e) {
        console.warn('Could not parse discount state', e);
        return null;
      }
    }
  }, {
    key: "saveDiscountState",
    value: function saveDiscountState(state) {
      try {
        localStorage.setItem(DISCOUNT_STORAGE_KEY, JSON.stringify(state));
      } catch (e) {
        console.warn('Could not save discount state', e);
      }
    }
  }, {
    key: "clearDiscountStorage",
    value: function clearDiscountStorage() {
      try {
        localStorage.removeItem(DISCOUNT_STORAGE_KEY);
        document.body.classList.remove('ed-dc-cl-enabled');
      } catch (e) {
        console.warn('Could not clear discount state', e);
      }
    }
  }]);

  return EdDiscountCollection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-discount-collection')) {
  customElements.define('ed-discount-collection', EdDiscountCollection);
}

/***/ }),

/***/ "./src/js/modules/ed-drag-scroll.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-drag-scroll.js ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_drag_scroll__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/drag-scroll */ "./src/js/helpers/drag-scroll.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


/**
 * Makes a horizontal scroll container inside it mouse-draggable on desktop
 * (e.g. Dawn's thumbnail slider on the PDP, which has no arrows anymore).
 *
 * <ed-drag-scroll>
 *     <ul data-ed-drag-scroll-track>…</ul>
 * </ed-drag-scroll>
 */

var EdDragScroll = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdDragScroll, _HTMLElement);

  var _super = _createSuper(EdDragScroll);

  function EdDragScroll() {
    _classCallCheck(this, EdDragScroll);

    return _super.apply(this, arguments);
  }

  _createClass(EdDragScroll, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.track = this.querySelector('[data-ed-drag-scroll-track]');
      if (!this.track) return;
      (0,_helpers_drag_scroll__WEBPACK_IMPORTED_MODULE_0__.attachDragScroll)(this.track);
    }
  }]);

  return EdDragScroll;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-drag-scroll')) {
  customElements.define('ed-drag-scroll', EdDragScroll);
}

/***/ }),

/***/ "./src/js/modules/ed-dropdown.js":
/*!***************************************!*\
  !*** ./src/js/modules/ed-dropdown.js ***!
  \***************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * <ed-dropdown> — a styled, accessible dropdown around a native <select>.
 *
 * Usage (Liquid):
 *   <ed-dropdown>
 *     <select aria-label="…" data-dropdown-select>…</select>
 *   </ed-dropdown>
 *
 * The <select> stays the source of truth: it keeps working in forms, the shown
 * value is read from it, and picking an option sets its value and dispatches a
 * bubbling `change` event on it — existing listeners on the select need no
 * changes. Toggling `disabled` on the select disables the dropdown as well.
 *
 * Trigger: by default a button showing the selected option plus a caret is
 * generated. Pass your own [data-dropdown-trigger] <button> containing a
 * [data-dropdown-value] element for the label to keep a custom look
 * (see snippets/ed-cart-subscription-plan.liquid).
 *
 * List: rendered as a popover in the browser's top layer, so it is never clipped
 * by overflow containers (cart drawer, accordions) and always sits on top. It
 * opens below the trigger and flips above it when there is not enough room;
 * data-dropdown-align="end" aligns it to the trigger's right edge instead.
 * Browsers without the Popover API fall back to the native select laid
 * invisibly over the trigger, so the dropdown still works there.
 *
 * Options: text from the <option>, `disabled` respected, `data-dropdown-separator`
 * on an option draws a divider above it.
 *
 * Public API: open(), close(), sync() — call sync() after changing the select's
 * value programmatically.
 */
var SUPPORTS_POPOVER = Object.prototype.hasOwnProperty.call(HTMLElement.prototype, 'popover');
var VIEWPORT_MARGIN = 8;
var TRIGGER_GAP = 4; // Below this much room under the trigger the list flips above it.

var MIN_SPACE_BELOW = 180;
var ICON_CARET = '<svg aria-hidden="true" focusable="false" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"/></svg>';
var ICON_CHECK = '<svg aria-hidden="true" focusable="false" viewBox="0 0 17 16" fill="none"><path d="M13.6088 4.66669L6.27547 12L2.94214 8.66669" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
var uid = 0;

var EdDropdown = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdDropdown, _HTMLElement);

  var _super = _createSuper(EdDropdown);

  function EdDropdown() {
    _classCallCheck(this, EdDropdown);

    return _super.apply(this, arguments);
  }

  _createClass(EdDropdown, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      // The drawer re-inserts nodes on re-render; only enhance once.
      if (this._enhanced) return;

      this._attachSelectors();

      if (!this.select) return;
      this._enhanced = true;

      if (!SUPPORTS_POPOVER) {
        this.classList.add('ed-dropdown--native');

        this._syncValue();

        return;
      }

      this._buildTrigger();

      this._buildList();

      this._attachListeners();

      this._syncValue();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._detachDismissListeners();

      if (this.observer) this.observer.disconnect();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.select = this.querySelector('[data-dropdown-select]') || this.querySelector('select');
      this.trigger = this.querySelector('[data-dropdown-trigger]');
      this.valueEl = this.querySelector('[data-dropdown-value]');
    }
  }, {
    key: "_buildTrigger",
    value: function _buildTrigger() {
      uid += 1;
      this.uid = uid;

      if (!this.trigger) {
        this.trigger = document.createElement('button');
        this.trigger.className = 'ed-dropdown__trigger';
        this.trigger.setAttribute('data-dropdown-trigger', '');
        this.trigger.innerHTML = "<span class=\"ed-dropdown__value\" data-dropdown-value></span><span class=\"ed-dropdown__caret\">".concat(ICON_CARET, "</span>");
        this.select.before(this.trigger);
        this.valueEl = this.trigger.querySelector('[data-dropdown-value]');
      }

      this.trigger.type = 'button';
      this.trigger.setAttribute('aria-haspopup', 'listbox');
      this.trigger.setAttribute('aria-expanded', 'false');
      this.trigger.disabled = this.select.disabled;
      if (!this.valueEl.id) this.valueEl.id = "ed-dropdown-".concat(this.uid, "-value"); // Accessible name: "<label>, <current value>". The label comes from the
      // select (aria-label / aria-labelledby) or its <label for>.

      this.labelId = this._resolveLabelId();
      var names = [this.labelId, this.valueEl.id].filter(Boolean).join(' ');
      this.trigger.setAttribute('aria-labelledby', names);
    }
  }, {
    key: "_resolveLabelId",
    value: function _resolveLabelId() {
      if (this.select.hasAttribute('aria-labelledby')) return this.select.getAttribute('aria-labelledby');
      var label = this.select.id ? document.querySelector("label[for=\"".concat(this.select.id, "\"]")) : null;

      if (label) {
        if (!label.id) label.id = "ed-dropdown-".concat(this.uid, "-label");
        return label.id;
      }

      var text = this.select.getAttribute('aria-label');
      if (!text) return '';
      var hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.id = "ed-dropdown-".concat(this.uid, "-label");
      hidden.textContent = text;
      this.trigger.before(hidden);
      return hidden.id;
    }
  }, {
    key: "_buildList",
    value: function _buildList() {
      this.list = document.createElement('div');
      this.list.className = 'ed-dropdown__list';
      this.list.id = "ed-dropdown-".concat(this.uid, "-list");
      this.list.setAttribute('popover', 'auto');
      this.list.setAttribute('role', 'listbox');
      this.list.setAttribute('tabindex', '-1');
      if (this.labelId) this.list.setAttribute('aria-labelledby', this.labelId);
      this.append(this.list);
      this.trigger.setAttribute('aria-controls', this.list.id);
      this.trigger.setAttribute('popovertarget', this.list.id);
    }
  }, {
    key: "_renderOptions",
    value: function _renderOptions() {
      var _this = this;

      this.list.innerHTML = '';
      Array.from(this.select.options).forEach(function (option) {
        var item = document.createElement('button');
        item.type = 'button';
        item.className = 'ed-dropdown__option';
        item.setAttribute('role', 'option');
        item.setAttribute('data-dropdown-option', '');
        item.dataset.value = option.value;
        item.tabIndex = -1;
        item.disabled = option.disabled;
        if (option.hasAttribute('data-dropdown-separator')) item.classList.add('ed-dropdown__option--separated');
        item.innerHTML = "<span class=\"ed-dropdown__option-label\">".concat(escapeHtml(option.text), "</span><span class=\"ed-dropdown__option-check\">").concat(ICON_CHECK, "</span>");

        _this.list.append(item);
      });

      this._syncSelected();
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;

      this.list.addEventListener('beforetoggle', this.handleBeforeToggle.bind(this));
      this.list.addEventListener('toggle', this.handleToggle.bind(this));
      this.list.addEventListener('click', this.handleOptionClick.bind(this));
      this.list.addEventListener('keydown', this.handleListKeydown.bind(this));
      this.list.addEventListener('focusout', this.handleFocusOut.bind(this));
      this.trigger.addEventListener('keydown', this.handleTriggerKeydown.bind(this)); // Clicking the open trigger closes via its popovertarget — mark that as
      // our own close so it is not mistaken for a light dismiss.

      this.trigger.addEventListener('click', function () {
        if (_this2.isOpen) _this2._closingSelf = true;
      }); // Escape: close only the list, never the surrounding drawer / modal —
      // keydown is handled here, the matching keyup is swallowed as well.

      this.addEventListener('keyup', function (event) {
        if (event.key === 'Escape' && _this2._swallowEscapeUp) {
          _this2._swallowEscapeUp = false;
          event.stopPropagation();
        }
      });
      this.observer = new MutationObserver(function () {
        _this2.trigger.disabled = _this2.select.disabled;

        _this2.classList.toggle('is-disabled', _this2.select.disabled);
      });
      this.observer.observe(this.select, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  }, {
    key: "isOpen",
    get: function get() {
      return !!this.list && this.list.matches(':popover-open');
    }
  }, {
    key: "open",
    value: function open() {
      // Going through the invoker button keeps the browser's invoker/light-dismiss
      // bookkeeping intact (clicking the trigger again closes instead of re-opening).
      if (!this.isOpen && !this.trigger.disabled) this.trigger.click();
    }
  }, {
    key: "close",
    value: function close() {
      if (!this.isOpen) return;
      this._closingSelf = true;
      this.list.hidePopover();
    }
  }, {
    key: "sync",
    value: function sync() {
      this._syncValue();

      if (this.isOpen) this._syncSelected();
    } // --- events ---

  }, {
    key: "handleBeforeToggle",
    value: function handleBeforeToggle(event) {
      if (event.newState === 'closed') {
        // Anything we did not initiate is a light dismiss (pointer outside).
        if (!this._closingSelf) this._swallowNextClick();
        return;
      } // Runs synchronously before the popover is shown, so the list is already
      // in place when it first paints.


      this._renderOptions();

      this._position();
    }
  }, {
    key: "handleToggle",
    value: function handleToggle(event) {
      var open = event.newState === 'open';
      this.classList.toggle('is-open', open);
      this.trigger.setAttribute('aria-expanded', String(open));

      if (open) {
        this._clampHorizontally();

        this._attachDismissListeners();

        this._focusOption(this._selectedOption() || this._enabledOptions()[0]);

        return;
      }

      this._closingSelf = false;

      this._detachDismissListeners(); // Hand focus back to the trigger unless the customer already moved on
      // (e.g. light dismiss by clicking another control).


      var active = document.activeElement;

      if (!active || active === document.body || this.list.contains(active)) {
        this.trigger.focus({
          preventScroll: true
        });
      }
    }
  }, {
    key: "handleOptionClick",
    value: function handleOptionClick(event) {
      var option = event.target.closest('[data-dropdown-option]');
      if (!option || option.disabled) return;

      this._choose(option.dataset.value);
    }
  }, {
    key: "handleTriggerKeydown",
    value: function handleTriggerKeydown(event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        this.open();
      }
    }
  }, {
    key: "handleListKeydown",
    value: function handleListKeydown(event) {
      var options = this._enabledOptions();

      var index = options.indexOf(document.activeElement);

      switch (event.key) {
        case 'ArrowDown':
          event.preventDefault();

          this._focusOption(options[Math.min(index + 1, options.length - 1)]);

          break;

        case 'ArrowUp':
          event.preventDefault();

          this._focusOption(options[Math.max(index - 1, 0)]);

          break;

        case 'Home':
          event.preventDefault();

          this._focusOption(options[0]);

          break;

        case 'End':
          event.preventDefault();

          this._focusOption(options[options.length - 1]);

          break;

        case 'Escape':
          event.preventDefault();
          event.stopPropagation();
          this._swallowEscapeUp = true;
          this.close();
          break;

        case 'Tab':
          this.close();
          break;

        default:
      }
    }
  }, {
    key: "handleFocusOut",
    value: function handleFocusOut(event) {
      if (!this.isOpen) return;
      if (event.relatedTarget && this.contains(event.relatedTarget)) return;
      this.close();
    } // --- internals ---

  }, {
    key: "_choose",
    value: function _choose(value) {
      var changed = this.select.value !== value;
      this.select.value = value;

      this._syncValue();

      this.close();
      if (changed) this.select.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }
  }, {
    key: "_syncValue",
    value: function _syncValue() {
      if (!this.valueEl) return;
      var option = this.select.selectedOptions[0];
      this.valueEl.textContent = option ? option.text : '';
    }
  }, {
    key: "_syncSelected",
    value: function _syncSelected() {
      var current = this.select.value;
      this.list.querySelectorAll('[data-dropdown-option]').forEach(function (option) {
        option.setAttribute('aria-selected', String(option.dataset.value === current));
      });
    }
  }, {
    key: "_selectedOption",
    value: function _selectedOption() {
      return this.list.querySelector('[data-dropdown-option][aria-selected="true"]:not(:disabled)');
    }
  }, {
    key: "_enabledOptions",
    value: function _enabledOptions() {
      return Array.from(this.list.querySelectorAll('[data-dropdown-option]:not(:disabled)'));
    }
  }, {
    key: "_focusOption",
    value: function _focusOption(option) {
      if (!option) return;
      this.list.querySelectorAll('[data-dropdown-option]').forEach(function (item) {
        item.tabIndex = -1;
      });
      option.tabIndex = 0;
      option.focus({
        preventScroll: true
      });
      option.scrollIntoView({
        block: 'nearest'
      });
    }
    /**
     * Fixed positioning relative to the viewport — valid because the popover lives
     * in the top layer, outside any transformed or scrolling ancestor. Nothing is
     * measured here (the list is not shown yet), so the list anchors to the
     * trigger's bottom edge, or to its top edge via `bottom` when flipping.
     */

  }, {
    key: "_position",
    value: function _position() {
      var rect = this.trigger.getBoundingClientRect();
      var vh = window.innerHeight;
      var spaceBelow = vh - rect.bottom - VIEWPORT_MARGIN;
      var spaceAbove = rect.top - VIEWPORT_MARGIN;
      var flip = spaceBelow < MIN_SPACE_BELOW && spaceAbove > spaceBelow;
      var style = this.list.style;
      style.minWidth = "".concat(Math.round(rect.width), "px");
      style.maxHeight = "".concat(Math.max(Math.floor(flip ? spaceAbove : spaceBelow) - TRIGGER_GAP, 80), "px");

      if (flip) {
        style.top = 'auto';
        style.bottom = "".concat(Math.round(vh - rect.top + TRIGGER_GAP), "px");
      } else {
        style.bottom = 'auto';
        style.top = "".concat(Math.round(rect.bottom + TRIGGER_GAP), "px");
      }

      if (this.dataset.dropdownAlign === 'end') {
        style.left = 'auto';
        style.right = "".concat(Math.round(window.innerWidth - rect.right), "px");
      } else {
        style.right = 'auto';
        style.left = "".concat(Math.round(rect.left), "px");
      }

      this.list.classList.toggle('ed-dropdown__list--above', flip);
    }
  }, {
    key: "_clampHorizontally",
    value: function _clampHorizontally() {
      var rect = this.list.getBoundingClientRect();
      var overflow = rect.right - (window.innerWidth - VIEWPORT_MARGIN);

      if (overflow > 0 && this.dataset.dropdownAlign !== 'end') {
        this.list.style.left = "".concat(Math.max(VIEWPORT_MARGIN, Math.round(rect.left - overflow)), "px");
      }
    }
    /**
     * A native select swallows the click that closes it; a popover's light
     * dismiss happens on pointerdown and lets the following click through to
     * whatever is underneath (quantity buttons, links). Swallow that one click
     * so closing the list never triggers something else by accident.
     */

  }, {
    key: "_swallowNextClick",
    value: function _swallowNextClick() {
      var closedAt = performance.now();

      var swallow = function swallow(event) {
        document.removeEventListener('click', swallow, true);
        if (performance.now() - closedAt > 500) return;
        event.preventDefault();
        event.stopPropagation();
      };

      document.addEventListener('click', swallow, true);
    } // The list is anchored to a viewport position — once the page or a scroll
    // container underneath moves, close instead of drifting away from the trigger.

  }, {
    key: "_attachDismissListeners",
    value: function _attachDismissListeners() {
      var _this3 = this;

      this._onScroll = function (event) {
        if (_this3.list.contains(event.target)) return;

        _this3.close();
      };

      this._onResize = function () {
        return _this3.close();
      };

      document.addEventListener('scroll', this._onScroll, {
        capture: true,
        passive: true
      });
      window.addEventListener('resize', this._onResize);
    }
  }, {
    key: "_detachDismissListeners",
    value: function _detachDismissListeners() {
      if (this._onScroll) document.removeEventListener('scroll', this._onScroll, {
        capture: true
      });
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      this._onScroll = null;
      this._onResize = null;
    }
  }]);

  return EdDropdown;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

function escapeHtml(text) {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}

if (!customElements.get('ed-dropdown')) {
  customElements.define('ed-dropdown', EdDropdown);
}

/***/ }),

/***/ "./src/js/modules/ed-featured-collection.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-featured-collection.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Featured collection - desktop swipe
 *
 * Dawn's <slider-component> scrolls the product grid via the arrows. On desktop its "next" arrow
 * can stay enabled at the end because of sub-pixel card widths, so while the desktop slider is
 * active (>= 990px and data-desktop-slider) this component sets the arrow states from the scroll
 * position instead and drives the scroll progress bar under the grid; on tablet/mobile Dawn keeps
 * handling the slider (incl. its counter) as before.
 */
var EdFeaturedCollection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdFeaturedCollection, _HTMLElement);

  var _super = _createSuper(EdFeaturedCollection);

  function EdFeaturedCollection() {
    _classCallCheck(this, EdFeaturedCollection);

    return _super.apply(this, arguments);
  }

  _createClass(EdFeaturedCollection, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!this.hasAttribute('data-desktop-slider')) return;

      this._attachSelectors();

      if (!this.slider || !this.prevButton || !this.nextButton || this.slides.length < 2) return;
      this.mql = window.matchMedia('(min-width: 990px)');

      this._attachListeners();

      this._requestUpdate();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.updateTimeout) window.clearTimeout(this.updateTimeout);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.slider = this.querySelector('[data-slider]');
      this.slides = this.querySelectorAll('[data-slide]');
      this.prevButton = this.querySelector('[data-slider-prev]');
      this.nextButton = this.querySelector('[data-slider-next]');
      this.scrollBar = this.querySelector('[data-scroll-bar]');
      this.scrollProgress = this.querySelector('[data-scroll-progress]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      // every update is deferred (macrotask) so it lands after Dawn's own scroll/resize handlers
      this.slider.addEventListener('scroll', this._requestUpdate.bind(this));
      this.mql.addEventListener('change', this._requestUpdate.bind(this));
      this.resizeObserver = new ResizeObserver(this._requestUpdate.bind(this));
      this.resizeObserver.observe(this.slider);
    }
  }, {
    key: "_requestUpdate",
    value: function _requestUpdate() {
      var _this = this;

      if (this.updateTimeout) return;
      this.updateTimeout = window.setTimeout(function () {
        _this.updateTimeout = null;

        _this._update();
      }, 0);
    }
  }, {
    key: "_update",
    value: function _update() {
      if (!this.mql.matches) return;
      var _this$slider = this.slider,
          scrollLeft = _this$slider.scrollLeft,
          clientWidth = _this$slider.clientWidth,
          scrollWidth = _this$slider.scrollWidth;
      var maxScrollLeft = scrollWidth - clientWidth;
      this.prevButton.toggleAttribute('disabled', scrollLeft <= 1);
      this.nextButton.toggleAttribute('disabled', scrollLeft >= maxScrollLeft - 1);
      if (!this.scrollBar || !this.scrollProgress) return; // only show the bar if there is something to scroll

      this.scrollBar.hidden = maxScrollLeft <= 1;
      this.scrollProgress.style.width = "".concat(Math.min(100, scrollLeft / maxScrollLeft * 100), "%");
    }
  }]);

  return EdFeaturedCollection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-featured-collection')) {
  customElements.define('ed-featured-collection', EdFeaturedCollection);
}

/***/ }),

/***/ "./src/js/modules/ed-gift-system.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-gift-system.js ***!
  \******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Shared free-gift selection popup used by the GWP progress bar (ed-gwp-item.liquid).
// The legacy progress bar / gift-item / auto-add logic (DER-403 A-variant) was removed;
// only the gift-selection popup web components remain, as the new ed-gwp system reuses them.
var GiftItemSelectPopup = /*#__PURE__*/function (_HTMLElement) {
  _inherits(GiftItemSelectPopup, _HTMLElement);

  var _super = _createSuper(GiftItemSelectPopup);

  function GiftItemSelectPopup() {
    var _this;

    _classCallCheck(this, GiftItemSelectPopup);

    _this = _super.call(this); // selectors

    _this.btnClose = _this.querySelector('.btn-close');

    _this._attachSelectors();

    _this._attachListeners();

    return _this;
  }

  _createClass(GiftItemSelectPopup, [{
    key: "open",
    get: function get() {
      return this.getAttribute('open');
    },
    set: function set(value) {
      this.setAttribute('open', value);
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cartType = document.body.getAttribute('data-cart-type');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.forms = this.querySelectorAll('form.popup-product-atc');
      this.buttons = this.querySelectorAll('button[type="submit"]');
      this.radioButtons = this.querySelectorAll('.gift-select-radio');
      this.itemContainers = this.querySelectorAll('.item-container');
      this.confirmButton = this.querySelector('.confirm-gift-button');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this2 = this;

      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.btnClose.addEventListener('click', this.closeModal.bind(this));
      this.forms.forEach(function (form) {
        form.submitButton = form.querySelector('button[type="submit"]');
        form.addEventListener('submit', _this2.onSubmit.bind(_this2));
      });

      if (this.radioButtons) {
        this.radioButtons.forEach(function (radio) {
          return radio.addEventListener('click', function (e) {
            return _this2.handleRadioClick(e);
          });
        });
      }

      if (this.itemContainers) {
        this.itemContainers.forEach(function (container) {
          return container.addEventListener('click', function (e) {
            return _this2.handleContainerClick(e);
          });
        });
      }

      if (this.confirmButton) {
        this.confirmButton.addEventListener('click', function (e) {
          e.preventDefault();

          _this2.handleConfirmClick();
        });
      }
    }
  }, {
    key: "handleConfirmClick",
    value: function handleConfirmClick() {
      var activeRadio = Array.from(this.radioButtons).find(function (rb) {
        return rb.checked;
      });

      if (activeRadio) {
        var form = activeRadio.closest('form');

        if (form) {
          var submitButton = form.querySelector('.popup-submit-button button');

          if (submitButton) {
            submitButton.click();
          }
        }
      }
    }
  }, {
    key: "handleRadioClick",
    value: function handleRadioClick(e) {
      this.radioButtons.forEach(function (rb) {
        return rb.checked = false;
      });
      e.currentTarget.checked = true;
    }
  }, {
    key: "handleContainerClick",
    value: function handleContainerClick(e) {
      var container = e.currentTarget;
      var radio = container.querySelector('.gift-select-radio');

      if (radio) {
        this.radioButtons.forEach(function (rb) {
          return rb.checked = false;
        });
        radio.checked = true;
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      var _this3 = this;

      event.preventDefault(); // prevent multiple free gift additions

      this.buttons.forEach(function (btn) {
        return btn.setAttribute('disabled', 'true');
      });

      if (this.cartType === 'page' && document.querySelector('.ed-ab-der-174')) {
        this.cart = document.querySelector('cart-notification');
      }

      var form = event.currentTarget;
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var formData = new FormData(form);

      if (this.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
          return section.id;
        }));
        formData.append('sections_url', window.location.pathname);
        formData.append('properties[_free-gift]', 'true');

        if (this.getAttribute('idx')) {
          formData.append('properties[_free-gift-idx]', this.getAttribute('idx'));
        }

        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
      fetch("/cart/add.js", config).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.status) {
          _this3.error = true;
          return;
        } else if (_this3.cartType == 'page') {
          window.location = '/cart';
          return;
        }

        document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
          detail: {
            isCustomAtcButton: true
          }
        }));
        _this3.error = false;

        var quickAddModal = _this3.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', function () {
            setTimeout(function () {
              _this3.cart.renderContents(response);
            });
          }, {
            once: true
          });
          quickAddModal.hide(true);
        } else {
          _this3.cart.renderContents(response);
        }
      })["catch"](function (e) {
        console.error(e);
      })["finally"](function () {
        if (_this3.cart && _this3.cart.classList.contains('is-empty')) _this3.cart.classList.remove('is-empty');

        _this3.btnClose.click();
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      this.open = false;
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.open = false;
      }
    }
  }]);

  return GiftItemSelectPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-gift-item-select-popup')) {
  customElements.define('ed-gift-item-select-popup', GiftItemSelectPopup);
}

var GiftItemSelectPopupItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(GiftItemSelectPopupItem, _HTMLElement2);

  var _super2 = _createSuper(GiftItemSelectPopupItem);

  function GiftItemSelectPopupItem() {
    var _this4;

    _classCallCheck(this, GiftItemSelectPopupItem);

    _this4 = _super2.call(this);
    _this4.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    _this4.btnClose = document.querySelector('.ed-gift-item-popup .btn-close');
    _this4.btnAddToCart = _this4.querySelector('.btn-container .page-button');
    _this4.atcButtons = document.querySelectorAll('.btn-container .page-button');
    _this4.btnAddToCartDrawer = _this4.querySelector('.btn-container .drawer-button');
    _this4.cartType = document.body.getAttribute('data-cart-type');
    _this4.isAbTestActive = document.querySelector('.ed-ab-der-174');
    _this4.forms = document.querySelectorAll('form.popup-product-atc-page'); // ELBDEV A/B-TEST LOGIC ed-ab-der-174

    document.addEventListener('ed-ab-der-174:added', function () {
      _this4.isAbTestActive = document.querySelector('.ed-ab-der-174');

      if (_this4.cartType === 'page' && _this4.isAbTestActive) {
        _this4.btnAddToCart.style.display = 'none';
        _this4.btnAddToCartDrawer.style.display = 'block';
      }
    });

    if (_this4.cartType === 'page' && _this4.isAbTestActive) {
      _this4.btnAddToCart.style.display = 'none';
      _this4.btnAddToCartDrawer.style.display = 'block';
    } // ELBDEV A/B-TEST LOGIC ed-ab-der-174


    _this4._attachListeners();

    return _this4;
  }

  _createClass(GiftItemSelectPopupItem, [{
    key: "productId",
    get: function get() {
      return this.getAttribute('product-id');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this5 = this;

      if (this.btnAddToCart) {
        this.btnAddToCart.addEventListener('click', this.addGiftToCart.bind(this));
      }

      if (this.forms) {
        this.forms.forEach(function (form) {
          form.addEventListener('submit', _this5.onSubmitDrawer.bind(_this5));
        });
      }
    }
  }, {
    key: "onSubmitDrawer",
    value: function onSubmitDrawer(event) {
      var _this6 = this;

      event.preventDefault();
      var form = event.currentTarget;
      var formVariantId = form.querySelector('input[type="hidden"][name="id"]').value;

      if (this.productId === formVariantId) {
        // ELBDEV A/B-TEST LOGIC ed-ab-der-174
        if (this.cartType === 'page' && document.querySelector('.ed-ab-der-174')) {
          this.cart = document.querySelector('cart-drawer');
        } else if (this.cartType === 'page') {
          this.cart = document.querySelector('cart-notification');
        }

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var formData = new FormData(form);

        if (this.cartType != 'page') {
          var parentPopup = this.closest('ed-gift-item-select-popup');
          var idx = parentPopup ? parentPopup.getAttribute('idx') : null;
          formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
            return section.id;
          }));
          formData.append('sections_url', window.location.pathname);
          formData.append('properties[_free-gift]', 'true');

          if (idx) {
            formData.append('properties[_free-gift-idx]', idx);
          }

          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
        fetch("/cart/add.js", config).then(function (response) {
          return response.json();
        }).then(function (response) {
          if (response.status) {
            _this6.error = true;
            return;
          } else if (_this6.cartType == 'page') {
            window.location = '/cart';
            return;
          }

          document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
            detail: {
              isCustomAtcButton: true
            }
          }));
          _this6.error = false;

          var quickAddModal = _this6.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener('modalClosed', function () {
              setTimeout(function () {
                _this6.cart.renderContents(response);
              });
            }, {
              once: true
            });
            quickAddModal.hide(true);
          } else {
            _this6.cart.renderContents(response);
          }
        })["catch"](function (e) {
          console.error(e);
        })["finally"](function () {
          if (_this6.cart && _this6.cart.classList.contains('is-empty')) _this6.cart.classList.remove('is-empty');

          _this6.btnClose.click();
        });
      }
    }
  }, {
    key: "addGiftToCart",
    value: function addGiftToCart() {
      // prevent multiple free gift additions
      this.atcButtons.forEach(function (btn) {
        return btn.setAttribute('disabled', 'true');
      });
      var parentPopup = this.closest('ed-gift-item-select-popup');
      var idx = parentPopup ? parentPopup.getAttribute('idx') : null;
      fetch("/cart/add.js", {
        body: JSON.stringify({
          id: this.productId,
          quantity: 1,
          properties: {
            '_free-gift': true,
            '_free-gift-idx': idx
          }
        }),
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      }).then(function () {
        location.reload();
      })["catch"](function (e) {
        console.error(e);
      });
    }
  }]);

  return GiftItemSelectPopupItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-gift-item-select-popup-item')) {
  customElements.define('ed-gift-item-select-popup-item', GiftItemSelectPopupItem);
}

/***/ }),

/***/ "./src/js/modules/ed-gwp-progress-bar.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-gwp-progress-bar.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

 // Guards the one-gift-limit removal loop against re-entrancy across cart re-renders.

var isRemovingGiftLimit = false;

var EdGwpProgressBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdGwpProgressBar, _HTMLElement);

  var _super = _createSuper(EdGwpProgressBar);

  function EdGwpProgressBar() {
    _classCallCheck(this, EdGwpProgressBar);

    return _super.apply(this, arguments);
  }

  _createClass(EdGwpProgressBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.cartTotal = parseFloat(this.getAttribute('cart-total')) || 0;
      this.textAllReached = this.getAttribute('text-all-milestones-reached') || '';

      this._attachSelectors();

      this.calculateProgress();

      this._enforceGiftRules();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.gwpItems = Array.from(this.querySelectorAll('ed-gwp-item'));
      this.gwpItemsContainer = this.querySelector('[data-gwp-items]');
      this.currentProgress = this.querySelector('[data-current-progress]');
      this.messageContainer = this.querySelector('[data-progress-bar-message]');

      if (this.messageContainer) {
        this.originalMessageTemplate = this.messageContainer.innerHTML;
      }

      this.missingAmountEl = this.querySelector('[data-missing-amount], .value');
      this.milestoneIcons = Array.from(this.querySelectorAll('[data-milestone-icon]:not(.pseudo)'));
    }
  }, {
    key: "calculateProgress",
    value: function calculateProgress() {
      if (!this.currentProgress) return;
      var targetsAttr = this.getAttribute('data-targets');
      var targets = targetsAttr.split(',').filter(function (v) {
        return v && !isNaN(v);
      }).map(Number);
      var total = this.cartTotal;
      var maxTarget = targets.at(-1);
      var progressPercent = 0;

      if (total >= maxTarget) {
        progressPercent = 100;
      } else {
        for (var i = 0; i < targets.length; i++) {
          var next = targets[i];
          var prev = targets[i - 1] || 0;

          if (total < next) {
            var range = next - prev;
            var withinRange = total - prev;
            var sectionPercent = 100 / targets.length;
            progressPercent = i * sectionPercent + withinRange / range * sectionPercent;
            break;
          }
        }
      } // Progress-Balken aktualisieren


      this.currentProgress.style.width = "".concat(progressPercent, "%");
      this.updateMilestoneIcons(targets, total);
      this.updateProgressMessage(targets, total);
      this.updateGwpItemsVisibility(total);
    }
  }, {
    key: "updateGwpItemsVisibility",
    value: function updateGwpItemsVisibility(total) {
      if (!this.gwpItemsContainer) return;
      var anyReached = this.gwpItems.some(function (item) {
        var target = parseFloat(item.getAttribute('data-target'));
        return total >= target;
      });
      this.gwpItemsContainer.setAttribute('data-active', anyReached ? 'true' : 'false');
    }
  }, {
    key: "updateMilestoneIcons",
    value: function updateMilestoneIcons(targets, total) {
      this.milestoneIcons.forEach(function (icon, index) {
        var target = targets[index];

        if (target && total >= target) {
          icon.classList.add('reached');
        } else {
          icon.classList.remove('reached');
        }
      });
    }
  }, {
    key: "updateProgressMessage",
    value: function updateProgressMessage(targets, total) {
      if (!this.messageContainer) return;
      var maxTarget = targets.at(-1); // Wenn alle Geschenke erreicht → andere Nachricht

      if (total >= maxTarget) {
        this.messageContainer.innerHTML = this.textAllReached;
        return;
      } // Find next target index


      var nextTargetIndex = targets.findIndex(function (target) {
        return total < target;
      });
      var nextTarget = targets[nextTargetIndex];

      if (nextTargetIndex !== -1) {
        var missing = Math.max(0, nextTarget - total);
        var formattedAmount = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(missing, window.edGiftSystemSettings.moneyFormat); // Tiered messages come from the theme settings (milestone_X_message), rendered as
        // positional data attributes in ed-gwp-main.liquid.

        var tieredMsg = this.getAttribute("data-msg-milestone-".concat(nextTargetIndex + 1));

        if (tieredMsg) {
          this.messageContainer.innerHTML = tieredMsg.replace('[amount]', formattedAmount);
        } else if (this.originalMessageTemplate) {
          // Fallback: the locale-rendered message from the initial Liquid markup
          this.messageContainer.innerHTML = this.originalMessageTemplate;
          var amountEl = this.messageContainer.querySelector('[data-missing-amount], .value');
          if (amountEl) amountEl.textContent = formattedAmount;
        }
      } else {
        this.messageContainer.innerHTML = this.textAllReached;
      }
    } // Cart-side gift enforcement (DER-403), run on every drawer re-render (connectedCallback — the
    // signal that fires after /cart/add.js). Reads the free-gift line items from the freshly-
    // rendered cart (data-* on the gift rows) and applies two rules:
    //   1) Threshold (always on): remove any gift whose milestone target is no longer met.
    //   2) One-gift limit (only when settings.enable_one_gift_limit): among the still-qualified
    //      gifts, keep only the highest tier and remove the rest.

  }, {
    key: "_enforceGiftRules",
    value: function _enforceGiftRules() {
      if (isRemovingGiftLimit) return;
      var rows = Array.from(document.querySelectorAll('.cart-item[data-free-gift="true"][data-line-key]'));
      if (!rows.length) return;
      var oneGiftLimit = document.body.getAttribute('data-one-gift-limit') === 'true';
      var cartTotal = this.cartTotal;
      var keysToRemove = [];
      var stillQualified = []; // Rule 1: drop gifts whose threshold is no longer met.

      rows.forEach(function (row) {
        var target = parseFloat(row.getAttribute('data-gift-target')) || 0;

        if (cartTotal < target) {
          keysToRemove.push(row.getAttribute('data-line-key'));
        } else {
          stillQualified.push(row);
        }
      }); // Rule 2: with one-gift-limit on, keep only the highest remaining tier.

      if (oneGiftLimit && stillQualified.length > 1) {
        var tierOf = function tierOf(row) {
          return parseInt(row.getAttribute('data-free-gift-idx'), 10) || 0;
        };

        stillQualified.sort(function (a, b) {
          return tierOf(b) - tierOf(a);
        });
        stillQualified.slice(1).forEach(function (row) {
          return keysToRemove.push(row.getAttribute('data-line-key'));
        });
      }

      var keys = _toConsumableArray(new Set(keysToRemove.filter(Boolean)));

      this._removeGiftLines(keys);
    }
  }, {
    key: "_removeGiftLines",
    value: function _removeGiftLines(keys) {
      if (!keys.length) return;
      isRemovingGiftLimit = true;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

      var removeNext = function removeNext(index) {
        if (index >= keys.length) {
          isRemovingGiftLimit = false;
          return;
        }

        var config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        var formData = new FormData();
        formData.append('id', keys[index]);
        formData.append('quantity', '0');

        if (cart && typeof cart.getSectionsToRender === 'function') {
          formData.append('sections', cart.getSectionsToRender().map(function (section) {
            return section.id;
          }));
          formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;
        fetch('/cart/change.js', config).then(function (response) {
          return response.json();
        }).then(function (state) {
          if (cart && typeof cart.renderContents === 'function') {
            cart.renderContents(state);
          }

          removeNext(index + 1);
        })["catch"](function (e) {
          console.error('gift-limit: remove failed', e);
          isRemovingGiftLimit = false;
        });
      };

      removeNext(0);
    }
  }]);

  return EdGwpProgressBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-gwp-progress-bar')) {
  customElements.define('ed-gwp-progress-bar', EdGwpProgressBar);
}

var EdGwpItem = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdGwpItem, _HTMLElement2);

  var _super2 = _createSuper(EdGwpItem);

  function EdGwpItem() {
    _classCallCheck(this, EdGwpItem);

    return _super2.apply(this, arguments);
  }

  _createClass(EdGwpItem, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._maybeAutoAdd();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.btnAddGwp = this.querySelector('[data-add-gwp]');
      this.popupComponent = this.querySelector('.ed-gift-item-popup');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      this.cartType = document.body.getAttribute('data-cart-type');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.btnAddGwp.addEventListener('click', this.handleAddGwp.bind(this));
    }
  }, {
    key: "_maybeAutoAdd",
    value: function _maybeAutoAdd() {
      var _this = this;

      // Auto-add only applies to single-product milestones (one definite gift).
      // Multi-product milestones require a user choice via the popup and are skipped.
      var autoAddEnabled = this.dataset.autoAdd === 'true';
      var reached = this.dataset.reached === 'true';
      var isSingle = this.classList.contains('single-gwp');
      if (!autoAddEnabled || !reached || !isSingle || this._autoAddTriggered) return;
      var form = this.querySelector('form.hidden-single-gwp-form');
      if (!form) return; // A milestone item is only rendered while its gift is NOT yet in the cart
      // (see ed-gwp-main.liquid). So an eligible+reached single-gwp item means the gift
      // still needs adding. Only the first eligible item adds per render pass — the cart
      // re-renders afterwards, this item disappears, and the next eligible item becomes
      // first on the following pass. This avoids a burst of concurrent /cart/add.js calls.

      var eligible = document.querySelectorAll('ed-gwp-item.single-gwp[data-auto-add="true"][data-reached="true"]');
      if (eligible[0] !== this) return;
      this._autoAddTriggered = true;
      setTimeout(function () {
        return _this.addSingleGwp(form);
      }, 50);
    }
  }, {
    key: "handleAddGwp",
    value: function handleAddGwp() {
      if (!this.dataset.reached || !this.dataset.reached === 'true') return;

      if (this.classList.contains('single-gwp')) {
        var form = this.querySelector('form.hidden-single-gwp-form');

        if (form) {
          this.addSingleGwp(form);
          return;
        }
      } // appending modal to body because when using the cart drawer, there is a clash between the z-index of the modal
      // and the transform attribute on the .drawer__inner element which prevents the modal from taking precedence


      document.body.appendChild(this.popupComponent);
      this.popupComponent.setAttribute('open', 'true');
    }
  }, {
    key: "addSingleGwp",
    value: function addSingleGwp(form) {
      var _this2 = this;

      this.btnAddGwp.setAttribute('disabled', 'true');
      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var formData = new FormData(form);

      if (this.cartType !== 'page' && this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
          return section.id;
        }));
        formData.append('sections_url', window.location.pathname);
        formData.append('properties[_free-gift]', 'true');
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
      fetch("/cart/add.js", config).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.status) {
          console.error('Error adding GWP:', response.description);

          _this2.btnAddGwp.removeAttribute('disabled');

          return;
        } else if (_this2.cartType === 'page') {
          window.location = '/cart';
          return;
        }

        document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
          detail: {
            isCustomAtcButton: true
          }
        }));

        if (_this2.cart) {
          _this2.cart.renderContents(response);
        }
      })["catch"](function (e) {
        console.error(e);

        _this2.btnAddGwp.removeAttribute('disabled');
      })["finally"](function () {
        if (_this2.cart && _this2.cart.classList.contains('is-empty')) {
          _this2.cart.classList.remove('is-empty');
        }
      });
    }
  }]);

  return EdGwpItem;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-gwp-item')) {
  customElements.define('ed-gwp-item', EdGwpItem);
}

/***/ }),

/***/ "./src/js/modules/ed-media-quote.js":
/*!******************************************!*\
  !*** ./src/js/modules/ed-media-quote.js ***!
  \******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdMediaQuoteVideo = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdMediaQuoteVideo, _HTMLElement);

  var _super = _createSuper(EdMediaQuoteVideo);

  function EdMediaQuoteVideo() {
    _classCallCheck(this, EdMediaQuoteVideo);

    return _super.apply(this, arguments);
  }

  _createClass(EdMediaQuoteVideo, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      if (!this.video) return;

      if (this.hasAttribute('data-autoplay')) {
        this._observeViewport();
      } else {
        this._attachListeners();
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('[data-play-button]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.playButton.addEventListener('click', this._play.bind(this));
      this.video.addEventListener('click', this._pause.bind(this));
      this.video.addEventListener('ended', this._showPlayButton.bind(this));
    }
  }, {
    key: "_play",
    value: function _play() {
      this.video.play();
      this.playButton.hidden = true;
    }
  }, {
    key: "_pause",
    value: function _pause() {
      if (this.video.paused) return;
      this.video.pause();

      this._showPlayButton();
    }
  }, {
    key: "_showPlayButton",
    value: function _showPlayButton() {
      this.playButton.hidden = false;
    } // video is rendered with preload="none" — playback (and download) only starts near the viewport

  }, {
    key: "_observeViewport",
    value: function _observeViewport() {
      var _this = this;

      if (!('IntersectionObserver' in window)) {
        this.video.play()["catch"](function () {});
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this.video.play()["catch"](function () {});
          } else {
            _this.video.pause();
          }
        });
      }, {
        rootMargin: '0px 0px 200px 0px'
      });
      observer.observe(this);
    }
  }]);

  return EdMediaQuoteVideo;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-media-quote-video')) {
  customElements.define('ed-media-quote-video', EdMediaQuoteVideo);
}

/***/ }),

/***/ "./src/js/modules/ed-moisturizer-list.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-moisturizer-list.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/scroll-to-element */ "./src/js/helpers/scroll-to-element.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var MoisturizerList = /*#__PURE__*/function (_HTMLElement) {
  _inherits(MoisturizerList, _HTMLElement);

  var _super = _createSuper(MoisturizerList);

  function MoisturizerList() {
    _classCallCheck(this, MoisturizerList);

    return _super.apply(this, arguments);
  }

  _createClass(MoisturizerList, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attackSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attackSelectors",
    value: function _attackSelectors() {
      this.items = this.querySelectorAll('.moisturizer-item[data-anchor-id]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.items.forEach(function (item) {
        item.addEventListener('click', _this.onItemClick.bind(_this));
      });
    }
  }, {
    key: "onItemClick",
    value: function onItemClick(e) {
      var currentItem = e.target;
      var target = currentItem.dataset.anchorId;
      (0,_helpers_scroll_to_element__WEBPACK_IMPORTED_MODULE_0__.scrollToElement)(target);
    }
  }]);

  return MoisturizerList;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-moisturizer-list')) {
  customElements.define('ed-moisturizer-list', MoisturizerList);
}

/***/ }),

/***/ "./src/js/modules/ed-popular-collections.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-popular-collections.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdPopularCollections = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdPopularCollections, _HTMLElement);

  var _super = _createSuper(EdPopularCollections);

  function EdPopularCollections() {
    _classCallCheck(this, EdPopularCollections);

    return _super.apply(this, arguments);
  }

  _createClass(EdPopularCollections, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.scrollElement = this.querySelector('.collection-list');
      this.scrollProgress = this.querySelector('.scroll-progress');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      this.scrollElement.addEventListener('scroll', this.onScroll.bind(this));
      window.addEventListener('resize', this.onWindowResize.bind(this));
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var scrolled = this.scrollElement.scrollLeft / (this.scrollElement.scrollWidth - this.scrollElement.clientWidth) * 100;
      this.scrollProgress.style.width = scrolled + "%";
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      if (this.scrollElement.offsetWidth < this.scrollElement.scrollWidth) {
        this.scrollElement.classList.add('scroll-bar-enable');
      } else {
        this.scrollElement.classList.remove('scroll-bar-enable');
        this.scrollElement.classList.add('scroll-bar-disable');
      }
    }
  }]);

  return EdPopularCollections;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-popular-collections')) {
  customElements.define('ed-popular-collections', EdPopularCollections);
}

/***/ }),

/***/ "./src/js/modules/ed-product-info-banner.js":
/*!**************************************************!*\
  !*** ./src/js/modules/ed-product-info-banner.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdProductInfoBanner = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdProductInfoBanner, _HTMLElement);

  var _super = _createSuper(EdProductInfoBanner);

  function EdProductInfoBanner() {
    _classCallCheck(this, EdProductInfoBanner);

    return _super.apply(this, arguments);
  }

  _createClass(EdProductInfoBanner, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      if (!EdProductInfoBanner._initialized) {
        EdProductInfoBanner._initialized = true;

        this._attachListeners();
      }
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      var timeout;
      document.addEventListener('variant:changed', function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
          return _this.addBanners();
        }, 100);
      });
    }
  }, {
    key: "addBanners",
    value: function addBanners() {
      var banners = document.querySelectorAll('ed-product-info-banner');
      var mediaItems = document.querySelectorAll('.product__media-list .product__media-item');

      if (banners[0] && mediaItems[0]) {
        var modalOpener = mediaItems[0].querySelector('.product__modal-opener');

        if (modalOpener) {
          modalOpener.appendChild(banners[0]);
        }
      }
    }
  }]);

  return EdProductInfoBanner;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-product-info-banner')) {
  customElements.define('ed-product-info-banner', EdProductInfoBanner);
}

/***/ }),

/***/ "./src/js/modules/ed-product-item-atc.js":
/*!***********************************************!*\
  !*** ./src/js/modules/ed-product-item-atc.js ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var ProductItemAtc = /*#__PURE__*/function (_HTMLElement) {
  _inherits(ProductItemAtc, _HTMLElement);

  var _super = _createSuper(ProductItemAtc);

  function ProductItemAtc() {
    _classCallCheck(this, ProductItemAtc);

    return _super.apply(this, arguments);
  }

  _createClass(ProductItemAtc, [{
    key: "selectType",
    get: function get() {
      return this.getAttribute('select-type');
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this.updatePrice();

      if (this.productVariantBadges.length > 0) {
        var _this$selectedValue;

        this.updateProductVariantBadges((_this$selectedValue = this.selectedValue) === null || _this$selectedValue === void 0 ? void 0 : _this$selectedValue.value);
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this$closest;

      this.cartType = document.body.getAttribute('data-cart-type');

      if (this.selectType === 'blocks') {
        this.fieldset = this.querySelector('fieldset');
        this.selectedValue = this.querySelector('input:checked');
      } else if (this.selectType === 'dropdown') {
        this.select = this.querySelector('select');
        this.selectedValue = this.select.options[this.select.selectedIndex];
      }

      this.form = this.firstElementChild;
      this.submitButton = this.querySelector('button[type="submit"]');
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      /** EXTERNAL: PRODUCT VARIANT BADGES **/

      this.productVariantBadges = (_this$closest = this.closest('.card[data-product-id]')) === null || _this$closest === void 0 ? void 0 : _this$closest.querySelectorAll('.product-badge[data-variant-id]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      // BLOCKS
      if (this.fieldset) {
        this.fieldset.addEventListener('change', this.onVariantChange.bind(this));
      } // SELECT


      if (this.select) {
        this.select.addEventListener('change', this.onVariantChange.bind(this));
      }

      if (this.getAttribute('cart-notification') === 'true') {
        this.form.addEventListener('submit', this.onSubmit.bind(this));
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(e) {
      e.preventDefault(); // ELBDEV A/B-TEST LOGIC ed-ab-der-466 — Quick-ATC öffnet ein Popup statt direkt hinzuzufügen
      // (Doku: src/js/modules/ed-quick-buy-popup.js)
      // Ausnahme: Einzelvarianten-Produkte adden direkt ohne Popup. Das variant-id-Attribut
      // wird in card-product-atc.liquid bei has_only_default_variant ODER variants.size == 1
      // gesetzt — deckt also auch Produkte wie den Adventskalender ab, deren einzige
      // Variante nicht "Default Title" heißt.

      if (document.querySelector('.ed-ab-der-466') && !this.getAttribute('variant-id') && this.dataset.productUrl && document.querySelector('ed-quick-buy-popup')) {
        // Loading-Feedback am Karten-Button, bis das Popup fertig geladen öffnet —
        // das Popup ruft resetQuickBuyLoading() auf (kein Content-Shift im Popup)
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('ed:quick-buy:open', {
          detail: {
            productUrl: this.dataset.productUrl,
            variantId: this.selectedValue ? this.selectedValue.value : this.getAttribute('variant-id'),
            opener: this
          }
        }));
        return;
      } // ELBDEV A/B-TEST LOGIC ed-ab-der-174


      if (this.cartType === 'page' && document.querySelector('.ed-ab-der-174')) {
        this.cart = document.querySelector('cart-drawer');
      } else if (this.cartType === 'page') {
        this.cart = document.querySelector('cart-notification');
      }

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      var variantId;

      if (this.selectedValue) {
        variantId = this.selectedValue.value;
      } else {
        variantId = this.getAttribute('variant-id');
      }

      this.addToCart(variantId);
    } // ELBDEV A/B-TEST LOGIC ed-ab-der-466 — vom Popup aufgerufen, sobald es fertig geladen öffnet

  }, {
    key: "resetQuickBuyLoading",
    value: function resetQuickBuyLoading() {
      this.submitButton.classList.remove('loading');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    }
  }, {
    key: "onVariantChange",
    value: function onVariantChange(e) {
      if (this.selectType === 'blocks') {
        this.selectedValue = this.querySelector('input:checked');
      } else if (this.selectType === 'dropdown') {
        this.selectedValue = this.select.options[this.select.selectedIndex];
      }

      this.updatePrice();
      /** EXTERNAL: PRODUCT VARIANT BADGES **/

      if (this.productVariantBadges.length > 0) {
        this.updateProductVariantBadges(this.selectedValue.value);
      }
    }
  }, {
    key: "updateProductVariantBadges",
    value: function updateProductVariantBadges(variantId) {
      this.productVariantBadges.forEach(function (badge) {
        if (badge.dataset.variantId === variantId) {
          badge.classList.add('active');
        } else {
          badge.classList.remove('active');
        }
      });
    }
  }, {
    key: "updatePrice",
    value: function updatePrice() {
      this.cardProduct = this.closest('.card-wrapper');
      var price = this.selectedValue.dataset.price;
      var comparePrice = this.selectedValue.dataset.comparePrice;
      /* BFCM 2025 */

      if (this.getAttribute('bfcm-collection') && this.selectedValue.dataset.bfcmPrice) {
        if (parseFloat(price) > parseFloat(comparePrice) || !comparePrice) {
          comparePrice = price;
        }

        price = this.selectedValue.dataset.bfcmPrice;
      }

      if (parseFloat(comparePrice) > parseFloat(price)) {
        var wrapper = this.cardProduct.querySelector('.price');

        if (wrapper) {
          wrapper.classList.add('price--on-sale');
        }

        this.salePriceElements = this.cardProduct.querySelectorAll('.price-item--sale');
        this.salePriceElements.forEach(function (element) {
          element.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, window.edGiftSystemSettings.moneyFormat);
        });
        this.regularPriceElements = this.cardProduct.querySelectorAll('.price-item--regular');
        this.regularPriceElements.forEach(function (element) {
          element.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(comparePrice, window.edGiftSystemSettings.moneyFormat);
        });
        this.cardProduct.querySelector('.price__sale').style.display = 'block';
        this.cardProduct.querySelector('.price__regular').style.display = 'none';
      } else {
        // just update single price
        var _wrapper = this.cardProduct.querySelector('.price.price--on-sale');

        if (_wrapper) {
          _wrapper.classList.remove('price--on-sale');
        }

        this.price = this.cardProduct.querySelector('.price__container .price-item--regular');
        this.price.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(price, window.edGiftSystemSettings.moneyFormat);
        this.cardProduct.querySelector('.price__container .price__sale').style.display = 'none';
        this.cardProduct.querySelector('.price__container .price__regular').style.display = 'block';
      } // Update unit price if available


      if (this.selectedValue.dataset.unitPrice) {
        this.cardProduct.querySelector('.price-item--last span').innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(this.selectedValue.dataset.unitPrice, window.edGiftSystemSettings.moneyFormat);
      }
    }
  }, {
    key: "addToCart",
    value: function addToCart(variantId) {
      var _this = this;

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var formData = new FormData(this.form);

      if (this.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
          return section.id;
        }));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
      fetch("".concat(routes.cart_add_url), config).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.status) {
          _this.handleErrorMessage(response.description);

          var soldOutMessage = _this.submitButton.querySelector('.sold-out-message');

          if (!soldOutMessage) return;

          _this.submitButton.setAttribute('aria-disabled', true);

          _this.submitButton.querySelector('span').classList.add('hidden');

          soldOutMessage.classList.remove('hidden');
          _this.error = true;
          return;
        } else if (_this.cartType == 'page') {
          window.location = window.routes.cart_url;
          return;
        }

        document.dispatchEvent(new CustomEvent('ed:good-choice-banner:toggle'));
        document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
          detail: {
            isCustomAtcButton: true
          }
        }));
        _this.error = false;

        var quickAddModal = _this.closest('quick-add-modal');

        if (quickAddModal) {
          document.body.addEventListener('modalClosed', function () {
            setTimeout(function () {
              _this.cart.renderContents(response);
            });
          }, {
            once: true
          });
          quickAddModal.hide(true);
        } else {
          _this.cart.renderContents(response);
        }
      })["catch"](function (e) {
        console.error(e);
      })["finally"](function () {
        _this.submitButton.classList.remove('loading');

        if (_this.cart && _this.cart.classList.contains('is-empty')) _this.cart.classList.remove('is-empty');
        if (!_this.error) _this.submitButton.removeAttribute('aria-disabled');

        _this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }
    /**** BFCM 2025 ****/

  }, {
    key: "preSelectDiscountedProduct",
    value: function preSelectDiscountedProduct() {
      var options = Array.from(this.select.options);
      var discountedOption = options.find(function (opt) {
        return opt.dataset.bfcmPrice;
      });

      if (discountedOption) {
        this.setAttribute('bfcm-collection', 'true');
        discountedOption.selected = true;
        this.onVariantChange();
        this.updateCardUrl(discountedOption);
      }
    }
  }, {
    key: "updateCardUrl",
    value: function updateCardUrl(option) {
      if (option && option.dataset.variantUrl) {
        this.cardProduct = this.closest('.card-wrapper');
        var links = this.cardProduct.querySelectorAll('a.full-unstyled-link');
        links.forEach(function (link) {
          link.href = option.dataset.variantUrl;
        });
      }
    }
    /**** END BFCM 2025 ****/

  }, {
    key: "createCartCountElement",
    value: function createCartCountElement() {
      var cartCountElement = document.createElement('div');
      cartCountElement.classList.add('cart-count-bubble');
      var ariaHiddenSpan = document.createElement('span');
      ariaHiddenSpan.setAttribute('aria-hidden', 'true');
      ariaHiddenSpan.textContent = '1';
      var visuallyHiddenSpan = document.createElement('span');
      visuallyHiddenSpan.classList.add('visually-hidden');
      visuallyHiddenSpan.textContent = '1 Artikel';
      cartCountElement.appendChild(ariaHiddenSpan);
      cartCountElement.appendChild(visuallyHiddenSpan);
      return cartCountElement;
    }
  }]);

  return ProductItemAtc;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-product-item-atc')) {
  customElements.define('ed-product-item-atc', ProductItemAtc);
}

/***/ }),

/***/ "./src/js/modules/ed-quick-buy-popup.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-quick-buy-popup.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * DER-466 — Quick-Buy-Popup (B-Variante)
 *
 * Öffnet auf 'ed:quick-buy:open' (dispatcht von ed-product-item-atc.js, wenn
 * html.ed-ab-der-466 gesetzt ist) ein Popup mit einem server-gerenderten
 * Auszug der PDP-Buy-Box. Der Inhalt kommt über die Section Rendering API:
 *
 *     GET {productUrl}?section_id=ed-quick-buy-product[&variant=123]
 *
 * Variantenwechsel im Popup rendert die Section mit &variant neu (Preis,
 * Grundpreis, Ergiebigkeit, Verfügbarkeit und ATC-Zustand kommen vom Server);
 * die Menge bleibt dabei erhalten. Antworten werden pro URL gecacht.
 *
 * A/B-TEST DER-466
 * A (Server-Default): direkter Quick-ATC, keine Klasse nötig.
 * B: das A/B-Tool setzt document.documentElement.classList.add('ed-ab-der-466').
 *
 * BETEILIGTE DATEIEN (für Rollout/Rollback):
 * - dieses Modul (+ Import in custom.js)
 * - src/scss/modules/ed-quick-buy-popup.scss (+ Import in custom.scss)
 * - snippets/ed-quick-buy-popup.liquid (+ Render in layout/theme.liquid)
 * - sections/ed-quick-buy-product.liquid
 * - markierte ed-ab-der-466-Blöcke in ed-product-item-atc.js
 * - data-product-url in snippets/card-product-atc.liquid
 * - Selektor-Erweiterung ".ed-quick-buy-product__variant-picker" in main-product.scss
 * Winner A: alles oben entfernen. Winner B: nur die Klassen-Prüfung im
 * markierten Block von ed-product-item-atc.js entfernen (Popup öffnet immer).
 */
var QUICK_BUY_SECTION_ID = 'ed-quick-buy-product';

var EdQuickBuyPopup = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdQuickBuyPopup, _HTMLElement);

  var _super = _createSuper(EdQuickBuyPopup);

  function EdQuickBuyPopup() {
    _classCallCheck(this, EdQuickBuyPopup);

    return _super.apply(this, arguments);
  }

  _createClass(EdQuickBuyPopup, [{
    key: "isOpen",
    get: function get() {
      return this.getAttribute('open') === 'true';
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._contentCache = new Map();
      this._abortController = null;

      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.container = this.querySelector('[data-ed-quick-buy-container]');
      this.loadingIndicator = this.querySelector('[data-ed-quick-buy-loading]');
      this.btnClose = this.querySelector('[data-ed-quick-buy-close]');
      this.overlay = this.querySelector('[data-ed-quick-buy-overlay]');
      this.cartType = document.body.getAttribute('data-cart-type');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('ed:quick-buy:open', this.handleOpenEvent.bind(this));
      document.addEventListener('keydown', this.handleKeydown.bind(this));
      this.btnClose.addEventListener('click', this.close.bind(this));
      this.overlay.addEventListener('click', this.close.bind(this)); // delegiert, da der Popup-Inhalt bei jedem Variantenwechsel neu gerendert wird

      this.container.addEventListener('change', this.handleVariantChange.bind(this));
      this.container.addEventListener('submit', this.handleSubmit.bind(this));
    }
  }, {
    key: "handleOpenEvent",
    value: function handleOpenEvent(e) {
      var _ref = e.detail || {},
          productUrl = _ref.productUrl,
          variantId = _ref.variantId,
          opener = _ref.opener;

      if (!productUrl) return;
      this.open(productUrl, variantId, opener);
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(e) {
      if (e.key === 'Escape' && this.isOpen) this.close();
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(productUrl, variantId, opener) {
        var success;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.productUrl = productUrl;
                this.container.innerHTML = ''; // Erst rendern, DANN öffnen — das Popup erscheint ohne Content-Shift;
                // das Loading-Feedback läuft solange über den Spinner des Karten-Buttons

                _context.next = 4;
                return this.renderContent(variantId);

              case 4:
                success = _context.sent;

                if (opener && typeof opener.resetQuickBuyLoading === 'function') {
                  opener.resetQuickBuyLoading();
                }

                if (success) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                this.setAttribute('open', 'true');
                document.body.classList.add('overflow-hidden', 'ed-quick-buy-open');
                this.btnClose.focus();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function open(_x, _x2, _x3) {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "close",
    value: function close() {
      if (this._abortController) this._abortController.abort();
      this.setAttribute('open', 'false');
      document.body.classList.remove('overflow-hidden', 'ed-quick-buy-open');
    }
  }, {
    key: "_buildSectionUrl",
    value: function _buildSectionUrl(variantId) {
      var url = new URL(this.productUrl, window.location.origin);
      url.searchParams.set('section_id', QUICK_BUY_SECTION_ID);
      if (variantId) url.searchParams.set('variant', variantId);
      return url.toString();
    }
  }, {
    key: "renderContent",
    value: function () {
      var _renderContent = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(variantId) {
        var _ref2,
            _ref2$preserveQuantit,
            preserveQuantity,
            url,
            quantityInput,
            quantity,
            contentHtml,
            response,
            html,
            doc,
            _content,
            content,
            newQuantityInput,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref2 = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {}, _ref2$preserveQuantit = _ref2.preserveQuantity, preserveQuantity = _ref2$preserveQuantit === void 0 ? false : _ref2$preserveQuantit;
                url = this._buildSectionUrl(variantId);
                quantityInput = this.container.querySelector('.quantity__input');
                quantity = preserveQuantity && quantityInput ? quantityInput.value : null;
                if (this._abortController) this._abortController.abort();
                this._abortController = new AbortController(); // interner Spinner nur beim Variantenwechsel im offenen Popup —
                // das Erstladen passiert bei geschlossenem Popup (Spinner am Karten-Button)

                this.loadingIndicator.hidden = !this.isOpen || this.container.childElementCount > 0;
                this.container.classList.add('is-loading');
                _context2.prev = 8;
                contentHtml = this._contentCache.get(url);

                if (contentHtml) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 13;
                return fetch(url, {
                  signal: this._abortController.signal,
                  cache: 'no-store'
                });

              case 13:
                response = _context2.sent;

                if (response.ok) {
                  _context2.next = 16;
                  break;
                }

                throw new Error("section request failed: ".concat(response.status));

              case 16:
                _context2.next = 18;
                return response.text();

              case 18:
                html = _context2.sent;
                // Nur den markierten Content-Block übernehmen — falls die Response
                // wider Erwarten eine volle Seite ist (z.B. Redirect/Fehlerfall),
                // landet so niemals die komplette PDP im Popup.
                doc = new DOMParser().parseFromString(html, 'text/html');
                _content = doc.querySelector('[data-ed-quick-buy-content]');

                if (_content) {
                  _context2.next = 23;
                  break;
                }

                throw new Error('no [data-ed-quick-buy-content] in section response');

              case 23:
                contentHtml = _content.outerHTML;

                this._contentCache.set(url, contentHtml);

              case 25:
                // innerHTML führt keine Scripts aus (variants-JSON bleibt lesbar);
                // die Stylesheet-<link>s im Content-Block laden beim ersten Öffnen mit.
                this.container.innerHTML = contentHtml; // ELBDEV: Reisegrößen-Logik (ed_der.has_travel_size) — kam die Anfrage
                // ohne ?variant=, markiert die Section die korrekte Startvariante;
                // einmalig neu rendern (mit Parameter rendert die Section keinen Marker mehr)

                content = this.container.querySelector('[data-ed-quick-buy-content]');

                if (!(content && content.dataset.edQuickBuyPreselectVariant)) {
                  _context2.next = 29;
                  break;
                }

                return _context2.abrupt("return", this.renderContent(content.dataset.edQuickBuyPreselectVariant, {
                  preserveQuantity: preserveQuantity
                }));

              case 29:
                if (quantity) {
                  newQuantityInput = this.container.querySelector('.quantity__input');
                  if (newQuantityInput) newQuantityInput.value = quantity;
                }

                _context2.next = 39;
                break;

              case 32:
                _context2.prev = 32;
                _context2.t0 = _context2["catch"](8);

                if (!(_context2.t0.name === 'AbortError')) {
                  _context2.next = 36;
                  break;
                }

                return _context2.abrupt("return", false);

              case 36:
                // Fallback: statt eines kaputten Popups direkt zur PDP navigieren
                console.error('[ed-quick-buy-popup]', _context2.t0);
                window.location.href = this.productUrl;
                return _context2.abrupt("return", false);

              case 39:
                this.loadingIndicator.hidden = true;
                this.container.classList.remove('is-loading');
                return _context2.abrupt("return", true);

              case 42:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 32]]);
      }));

      function renderContent(_x4) {
        return _renderContent.apply(this, arguments);
      }

      return renderContent;
    }()
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(e) {
      if (!e.target.hasAttribute('data-ed-quick-buy-option')) return;

      var variantId = this._getSelectedVariantId();

      if (!variantId) return;
      this.renderContent(variantId, {
        preserveQuantity: true
      });
    }
  }, {
    key: "_getSelectedVariantId",
    value: function _getSelectedVariantId() {
      var picker = this.container.querySelector('[data-ed-quick-buy-variant-picker]');
      if (!picker) return null;
      var variants = JSON.parse(picker.querySelector('[data-ed-quick-buy-variants]').textContent);
      var selectedOptions = Array.from(picker.querySelectorAll('fieldset')).map(function (fieldset) {
        var checked = fieldset.querySelector('input:checked');
        return checked ? checked.value : null;
      });
      var variant = variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        });
      });
      return variant ? variant.id : null;
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit(e) {
      e.preventDefault();
      var form = e.target;
      this.submitButton = form.querySelector('button[type="submit"]');
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification'); // ELBDEV A/B-TEST LOGIC ed-ab-der-174

      if (this.cartType === 'page' && document.querySelector('.ed-ab-der-174')) {
        this.cart = document.querySelector('cart-drawer');
      } else if (this.cartType === 'page') {
        this.cart = document.querySelector('cart-notification');
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      form.querySelector('.loading-overlay__spinner').classList.remove('hidden');
      this.addToCart(form);
    }
  }, {
    key: "addToCart",
    value: function addToCart(form) {
      var _this = this;

      var config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      var formData = new FormData(form);

      if (this.cartType != 'page') {
        formData.append('sections', this.cart.getSectionsToRender().map(function (section) {
          return section.id;
        }));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;
      fetch("".concat(routes.cart_add_url), config).then(function (response) {
        return response.json();
      }).then(function (response) {
        if (response.status) {
          _this.handleErrorMessage(form, response.description);

          _this.error = true;
          return;
        } else if (_this.cartType == 'page') {
          window.location = window.routes.cart_url;
          return;
        }

        _this.error = false;

        _this.close();

        document.dispatchEvent(new CustomEvent('ed:good-choice-banner:toggle'));
        document.dispatchEvent(new CustomEvent('ed:handle-cart-drawer', {
          detail: {
            isCustomAtcButton: true
          }
        }));

        _this.cart.renderContents(response);
      })["catch"](function (e) {
        console.error(e);
      })["finally"](function () {
        _this.submitButton.classList.remove('loading');

        if (_this.cart && _this.cart.classList.contains('is-empty')) _this.cart.classList.remove('is-empty'); // anders als beim Karten-ATC auch im Fehlerfall wieder aktivieren:
        // im Popup kann der Nutzer die Menge korrigieren und erneut klicken

        _this.submitButton.removeAttribute('aria-disabled');

        form.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    }
  }, {
    key: "handleErrorMessage",
    value: function handleErrorMessage(form, errorMessage) {
      var wrapper = form.querySelector('.product-form__error-message-wrapper');
      if (!wrapper) return;
      wrapper.toggleAttribute('hidden', !errorMessage);
      wrapper.querySelector('.product-form__error-message').textContent = errorMessage || '';
    }
  }]);

  return EdQuickBuyPopup;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-quick-buy-popup')) {
  customElements.define('ed-quick-buy-popup', EdQuickBuyPopup);
}

/***/ }),

/***/ "./src/js/modules/ed-recharge-widget.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-recharge-widget.js ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money */ "./src/js/helpers/format-money.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var RechargeWidget = /*#__PURE__*/function (_HTMLElement) {
  _inherits(RechargeWidget, _HTMLElement);

  var _super = _createSuper(RechargeWidget);

  function RechargeWidget() {
    _classCallCheck(this, RechargeWidget);

    return _super.apply(this, arguments);
  }

  _createClass(RechargeWidget, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      if (this._applyPreselection(this.variantData.id)) {
        this.handleSubscriptionChange();
      }
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.widget = this.querySelector('.subscription-widget');
      this.subscriptionOptions = this.querySelectorAll('.subscription-option');
      this.sellingPlanSelector = this.querySelector('#selling-plan-select');
      this.addToCartForm = document.querySelector('product-form form[action="/cart/add"]');
      this.sellingPlanInput = this.addToCartForm.querySelector('input[name="selling_plan"]') || document.createElement('input');
      this.oneTime = this.querySelector('.one-time');
      this.oneTimePrice = this.querySelector('.one-time-option-price');
      this.subscriptionPrice = this.querySelector('[data-subscription-price]');
      this.subscriptionComparePrice = this.querySelector('.subscription-option-compare-price');
      this.savingsBadge = this.querySelector('.subscription-widget__savings-badge'); // Mehrere Elemente, weil A- und B-Textvariante parallel im DOM liegen (DER-458-v2)

      this.optionTextElements = this.querySelectorAll('[data-text-template]');
      this.variantData = JSON.parse(this.querySelector('[data-variant-json]').dataset.variantJson);
      this.subscription = this.querySelector('.subscription-option[data-option-type="subscription"]'); // Varianten-Maps aus ed-recharge-widget.liquid: Vorauswahl aus dem Metafeld
      // ed_der.preselect_subscription, Treuepunkte aus Preis × Faktor (DER-458-v2)

      this.preselectSubscriptionMap = this._parseVariantMap(this.dataset.preselectSubscriptionMap);
      this.loyaltyPointsMap = this._parseVariantMap(this.dataset.loyaltyPointsMap);

      if (!this.sellingPlanInput.name) {
        this.sellingPlanInput.type = 'hidden';
        this.sellingPlanInput.name = 'selling_plan';
        this.addToCartForm.appendChild(this.sellingPlanInput);
      }

      this.infoIcon = this.querySelector('.subscription-info-icon');
      this.infoIconModal = this.querySelector('.subscription-info-modal');
      this.modalCloseIcon = this.querySelector('.subscription-modal-close-container svg');
      this.modalCloseButton = this.querySelector('.subscription-modal-dismiss-btn button');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      if (this.subscriptionOptions) {
        this.subscriptionOptions.forEach(function (option) {
          option.addEventListener('click', function (e) {
            return _this.radioButtons(e);
          });
        });
      }

      if (this.sellingPlanSelector) {
        this.sellingPlanSelector.addEventListener('change', function () {
          return _this.handleSubscriptionChange();
        });
      }

      if (this.infoIcon) {
        this.infoIcon.addEventListener('click', function (e) {
          return _this.handleInfoIconClick(e);
        });
      }

      if (this.modalCloseIcon) {
        this.modalCloseIcon.addEventListener('click', function () {
          return _this.closeInfoModal(_this.infoIconModal);
        });
      }

      if (this.modalCloseButton) {
        this.modalCloseButton.addEventListener('click', function () {
          return _this.closeInfoModal(_this.infoIconModal);
        });
      }

      document.addEventListener('variant:changed', function (e) {
        return _this.handleVariantChange(e);
      });
    }
  }, {
    key: "_parseVariantMap",
    value: function _parseVariantMap(raw) {
      try {
        return JSON.parse(raw || '{}');
      } catch (error) {
        return {};
      }
    }
    /**
     * DER-458-v2 — füllt die Platzhalter ((percentage)) und ((points)) in den
     * Optionstexten. Läuft bei jedem Varianten- und Intervallwechsel, weil beide
     * Werte davon abhängen.
     */

  }, {
    key: "_renderOptionTexts",
    value: function _renderOptionTexts(savingsPercentage) {
      var _this$loyaltyPointsMa;

      var points = (_this$loyaltyPointsMa = this.loyaltyPointsMap[this.variantData.id]) !== null && _this$loyaltyPointsMa !== void 0 ? _this$loyaltyPointsMa : '';
      var percentage = savingsPercentage == null ? '' : savingsPercentage + '%';
      this.optionTextElements.forEach(function (element) {
        var template = element.dataset.textTemplate; // Platzhalter ohne Wert würde eine Lücke im Satz hinterlassen ("und  Treuepunkte
        // sammeln") — in dem Fall lieber die ganze Subheadline ausblenden.

        var incomplete = template.includes('((points))') && points === '' || template.includes('((percentage))') && percentage === '';
        element.classList.toggle('hidden', incomplete);
        element.innerText = template.replace('((percentage))', percentage).replace('((points))', points);
      });
    }
    /**
     * DER-458-v2 — soll für diese Variante "Im Abo kaufen" vorausgewählt sein?
     * Innerhalb der B-Variante: html-Klasse als Override, sonst das Varianten-
     * Metafeld ed_der.preselect_subscription, sonst "Einmalig kaufen".
     */

  }, {
    key: "_shouldPreselectSubscription",
    value: function _shouldPreselectSubscription(variantId) {
      var root = document.documentElement.classList;
      if (root.contains('ed-ab-der-458-v2-preselect-one-time')) return false;
      if (root.contains('ed-ab-der-458-v2-preselect-subscription')) return true;
      return this.preselectSubscriptionMap[variantId] === true;
    }
    /**
     * Setzt die Auswahl auf den Standard der Variante. Läuft beim Init und bei
     * jedem Variantenwechsel, weil die Vorauswahl variantenabhängig ist.
     * Gibt zurück, ob sich die Auswahl geändert hat.
     */

  }, {
    key: "_applyPreselection",
    value: function _applyPreselection(variantId) {
      // Gehört zur B-Variante. In A wird hier gar nichts angefasst — weder die
      // Vorauswahl beim Laden noch die Auswahl beim Variantenwechsel.
      if (!document.documentElement.classList.contains('ed-ab-der-458-v2-b')) return false;
      if (this.classList.contains('hidden')) return false;
      if (!this.subscription || !this.oneTime) return false;
      var target = this._shouldPreselectSubscription(variantId) ? this.subscription : this.oneTime;
      if (target.classList.contains('selected-option')) return false;
      this.subscriptionOptions.forEach(function (option) {
        return option.classList.remove('selected-option');
      });
      target.classList.add('selected-option');
      return true;
    }
  }, {
    key: "handleVariantChange",
    value: function handleVariantChange(e) {
      this.variantData = e.detail.newVariant;

      if (e.detail.newVariant.selling_plan_allocations.length === 0) {
        this.subscriptionOptions.forEach(function (option) {
          return option.classList.remove('selected-option');
        });
        this.oneTime.classList.add('selected-option');
        this.sellingPlanInput.value = '';
        this.classList.add('hidden');
        this.updatePrice(e);
        return;
      }

      this.classList.remove('hidden');
      this.updatePrice(e); // Erst nach updatePrice, sonst überschreibt der Variantenpreis den Abo-Preis

      this._applyPreselection(e.detail.newVariant.id);

      this.handleSubscriptionChange();
    }
  }, {
    key: "updatePrice",
    value: function updatePrice(e, allocation) {
      if (e) {
        if (this.oneTimePrice) {
          this.oneTimePrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(e.detail.newVariant.price, window.edGiftSystemSettings.moneyFormat);
        }

        if (this.subscriptionPrice) {
          this.subscriptionPrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(e.detail.newVariant.price, window.edGiftSystemSettings.moneyFormat);
        }
      }

      if (allocation) {
        if (allocation.compare_at_price > allocation.price) {
          this.subscriptionComparePrice.innerHTML = "<s>".concat((0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(allocation.compare_at_price, window.edGiftSystemSettings.moneyFormat), "</s>");
          this.subscriptionPrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(allocation.price, window.edGiftSystemSettings.moneyFormat);
          this.subscriptionComparePrice.classList.remove('hidden');
        } else {
          this.subscriptionPrice.innerText = (0,_helpers_format_money__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(allocation.price, window.edGiftSystemSettings.moneyFormat);
        }
      }
    }
  }, {
    key: "radioButtons",
    value: function radioButtons(e) {
      this.subscriptionOptions.forEach(function (option) {
        return option.classList.remove('selected-option');
      });
      var selectedOption = e.target.closest('.subscription-option');

      if (selectedOption) {
        selectedOption.classList.add('selected-option');
      }

      this.handleSubscriptionChange();
    }
  }, {
    key: "handleSubscriptionChange",
    value: function handleSubscriptionChange() {
      var _this$sellingPlanSele;

      var selectedOption = this.widget.querySelector('.subscription-option.selected-option');
      var selectedPlan = (_this$sellingPlanSele = this.sellingPlanSelector) === null || _this$sellingPlanSele === void 0 ? void 0 : _this$sellingPlanSele.value;
      if (!selectedOption) return;

      if (selectedOption.dataset.optionType === 'one-time') {
        this.sellingPlanInput.value = '';
      } else {
        if (selectedOption && selectedPlan && this.sellingPlanInput) {
          this.sellingPlanInput.value = selectedPlan;
        }
      }

      this.updateSubscriptionDiscount(selectedPlan);
    }
  }, {
    key: "updateSubscriptionDiscount",
    value: function updateSubscriptionDiscount(value) {
      var selectedAllocation = this.variantData.selling_plan_allocations.find(function (allocation) {
        return allocation.selling_plan_id === parseInt(value);
      });

      if (selectedAllocation && selectedAllocation.compare_at_price > selectedAllocation.price) {
        var savings = selectedAllocation.compare_at_price - selectedAllocation.price;
        var savingsPercentage = savings * 100 / selectedAllocation.compare_at_price;

        this._renderOptionTexts(savingsPercentage);

        if (this.savingsBadge) {
          this.savingsBadge.innerText = savingsPercentage + '%';
          this.savingsBadge.classList.remove('hidden');
        }
      } else {
        var _this$savingsBadge, _this$subscriptionCom;

        this._renderOptionTexts(null);

        (_this$savingsBadge = this.savingsBadge) === null || _this$savingsBadge === void 0 ? void 0 : _this$savingsBadge.classList.add('hidden');
        (_this$subscriptionCom = this.subscriptionComparePrice) === null || _this$subscriptionCom === void 0 ? void 0 : _this$subscriptionCom.classList.add('hidden');
      }

      this.updatePrice(null, selectedAllocation);
    }
  }, {
    key: "handleInfoIconClick",
    value: function handleInfoIconClick(e) {
      var _this2 = this;

      e.stopPropagation();
      if (!this.infoIconModal) return;

      if (!this.infoIconModal.dataset.appended) {
        this.infoIconModal.dataset.appended = 'true';
        document.body.appendChild(this.infoIconModal);
      }

      if (!this.infoIconModal.classList.contains('hidden')) return this.closeInfoModal(this.infoIconModal);
      var backdrop = document.createElement('div');
      backdrop.className = 'subscription-info-backdrop';
      backdrop.style.display = 'block';
      document.body.appendChild(backdrop);
      this.infoIconModal.classList.remove('hidden');

      var close = function close() {
        return _this2.closeInfoModal(_this2.infoIconModal, backdrop);
      };

      backdrop.addEventListener('click', close, {
        once: true
      });
      document.addEventListener('keydown', function escHandler(ev) {
        if (ev.key === 'Escape') {
          close();
          document.removeEventListener('keydown', escHandler);
        }
      });
    }
  }, {
    key: "closeInfoModal",
    value: function closeInfoModal() {
      var _document$querySelect;

      var modal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.infoIconModal;
      modal === null || modal === void 0 ? void 0 : modal.classList.add('hidden');
      (_document$querySelect = document.querySelector('.subscription-info-backdrop')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.remove();
    }
  }]);

  return RechargeWidget;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-recharge-widget')) {
  customElements.define('ed-recharge-widget', RechargeWidget);
}

/***/ }),

/***/ "./src/js/modules/ed-section-teaser-boxes.js":
/*!***************************************************!*\
  !*** ./src/js/modules/ed-section-teaser-boxes.js ***!
  \***************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdSectionTeaserBoxes = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdSectionTeaserBoxes, _HTMLElement);

  var _super = _createSuper(EdSectionTeaserBoxes);

  function EdSectionTeaserBoxes() {
    _classCallCheck(this, EdSectionTeaserBoxes);

    return _super.apply(this, arguments);
  }

  _createClass(EdSectionTeaserBoxes, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.scrollElement = this.querySelector('slider-component ul');
      this.scrollProgress = this.querySelector('[data-scroll-progress]');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.scrollElement.addEventListener('scroll', this.onScroll.bind(this));
      window.addEventListener('resize', this.onWindowResize.bind(this));
      this.querySelectorAll('[data-trigger-gorgias]').forEach(function (button) {
        button.addEventListener('click', function (e) {
          e.preventDefault();

          _this.openGorgiasChat();
        });
      });
    }
  }, {
    key: "openGorgiasChat",
    value: function openGorgiasChat() {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open();
      } else {
        window.addEventListener('gorgias-widget-loaded', function () {
          window.GorgiasChat.open();
        }, {
          once: true
        });
      }
    }
  }, {
    key: "onScroll",
    value: function onScroll() {
      var scrolled = this.scrollElement.scrollLeft / (this.scrollElement.scrollWidth - this.scrollElement.clientWidth) * 100;
      this.scrollProgress.style.width = scrolled + "%";
    }
  }, {
    key: "onWindowResize",
    value: function onWindowResize() {
      if (this.scrollElement.offsetWidth < this.scrollElement.scrollWidth) {
        this.scrollElement.classList.add('scroll-bar-enable');
      } else {
        this.scrollElement.classList.remove('scroll-bar-enable');
        this.scrollElement.classList.add('scroll-bar-disable');
      }
    }
  }]);

  return EdSectionTeaserBoxes;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-section-teaser-boxes')) {
  customElements.define('ed-section-teaser-boxes', EdSectionTeaserBoxes);
}

/***/ }),

/***/ "./src/js/modules/ed-shipping-note.js":
/*!********************************************!*\
  !*** ./src/js/modules/ed-shipping-note.js ***!
  \********************************************/
/***/ (() => {

/*
Keeps the shipping-related buy box notes in sync with the selected variant.

Dawn's renderProductInfo() only swaps #price-<section>. Both the tax/shipping line
(.product__tax) and the availability line (shipping-info) sit outside of it, so they
would keep the server-rendered state of the initial page load on every variant switch.
The initial state comes from Liquid, this only handles the client-side switches.
*/
// Versandsatz hinter "inkl. MwSt." — entfällt bei Varianten ohne Versandpflicht (z.B. Event-Tickets)
function updateShippingNotes(variant) {
  document.querySelectorAll('[data-ed-shipping-note]').forEach(function (note) {
    note.hidden = variant.requires_shipping === false;
  });
} // Verfügbarkeitszeile: Ampel-Klasse plus der Text, der die Versandaussage enthält


function updateShippingInfo(variant) {
  var shippingInfo = document.querySelector('[data-ed-shipping-info]');
  if (!shippingInfo) return;
  shippingInfo.classList.toggle('available', Boolean(variant.available));
  var availableText = shippingInfo.querySelector('.available-text');
  if (!availableText) return;
  availableText.innerHTML = variant.requires_shipping === false ? availableText.dataset.availableNoShippingText : availableText.dataset.availableText;
}

document.addEventListener('variant:changed', function (e) {
  var variant = e.detail.newVariant;
  if (!variant) return;
  updateShippingNotes(variant);
  updateShippingInfo(variant);
});

/***/ }),

/***/ "./src/js/modules/ed-sticky-good-choice.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-sticky-good-choice.js ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _helpers_format_money_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers/format-money.js */ "./src/js/helpers/format-money.js");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }



var StickyGoodChoiceBanner = /*#__PURE__*/function (_HTMLElement) {
  _inherits(StickyGoodChoiceBanner, _HTMLElement);

  var _super = _createSuper(StickyGoodChoiceBanner);

  function StickyGoodChoiceBanner() {
    _classCallCheck(this, StickyGoodChoiceBanner);

    return _super.apply(this, arguments);
  }

  _createClass(StickyGoodChoiceBanner, [{
    key: "duration",
    get: function get() {
      return this.getAttribute('duration');
    }
  }, {
    key: "active",
    set: function set(value) {
      this.setAttribute('active', value);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.cartIconContainer = this.querySelector('.icon-cart-container');
      this.freeShippingContainer = this.querySelector('.ed-free-shipping__text');
      this.freeShippingTextContent = this.querySelector('.ed-free-shipping__text-content');
      this.closeButton = this.querySelector('.container-header__close'); // TODO: UPDATE

      this.cartType = document.body.getAttribute('data-cart-type');
      this.defaultCartIcon = document.querySelector('.header__icon--cart');
      this.toCartButtons = document.querySelectorAll('.to-cart-button');
      this.cartIconBubble = document.querySelector('#cart-icon-bubble');
      this.isAbTestActive = document.querySelector('.ed-ab-der-174'); // Get settings from data attributes

      this.freeShippingTarget = parseInt(this.getAttribute('data-free-shipping-target')) || 0;
      this.shippingPrice = parseInt(this.getAttribute('data-shipping-price')) || 0;
      this.enableSubscriptionFreeShipping = this.getAttribute('data-subscription-free-shipping') === 'true';
      this.moneyFormat = this.getAttribute('data-money-format') || window.edGiftSystemSettings.moneyFormat;
      this.closeTimeout = null;
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      document.addEventListener('ed:good-choice-banner:toggle', this.open.bind(this));

      if (this.toCartButtons.length > 0) {
        this.toCartButtons.forEach(function (button) {
          button.addEventListener('click', _this.handleToCartButtonClick.bind(_this));
        });
      }

      if (this.closeButton) {
        this.closeButton.addEventListener('click', this.close.bind(this));
      } // ELBDEV A/B-TEST LOGIC ed-ab-der-174


      document.addEventListener('ed-ab-der-174:added', function () {
        _this.isAbTestActive = document.querySelector('.ed-ab-der-174');
      });
    }
  }, {
    key: "handleToCartButtonClick",
    value: function handleToCartButtonClick(event) {
      // ELBDEV A/B-TEST LOGIC ed-ab-der-174
      if (this.cartType === 'page' && this.isAbTestActive || this.cartType === 'drawer') {
        event.preventDefault();

        if (this.cartIconBubble) {
          this.cartIconBubble.click();
          setTimeout(function () {
            return document.body.classList.add('overflow-hidden');
          });
        }
      }
    } // TODO: UPDATE

  }, {
    key: "getCartIcon",
    value: function getCartIcon() {
      this.defaultCartIcon = document.querySelector('.header__icon--cart');
    }
  }, {
    key: "updateFreeShippingText",
    value: function () {
      var _updateFreeShippingText = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, cart, shippingPrice, onlyVirtualProducts, onlySubscriptionProducts, _iterator, _step, item, freeShippingRest, formattedAmount, missingText, goalText;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return fetch('/cart.js');

              case 3:
                response = _context.sent;
                _context.next = 6;
                return response.json();

              case 6:
                cart = _context.sent;
                shippingPrice = this.shippingPrice;
                onlyVirtualProducts = true;
                onlySubscriptionProducts = true;
                _iterator = _createForOfIteratorHelper(cart.items);

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    item = _step.value;

                    if (item.requires_shipping) {
                      onlyVirtualProducts = false;
                    }

                    if (!item.selling_plan_allocation) {
                      onlySubscriptionProducts = false;
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                if (onlyVirtualProducts) {
                  shippingPrice = 0;
                } else if (onlySubscriptionProducts && this.enableSubscriptionFreeShipping) {
                  shippingPrice = 0;
                }

                if (cart.total_price >= this.freeShippingTarget && this.freeShippingTarget > 0) {
                  shippingPrice = 0;
                }

                freeShippingRest = this.freeShippingTarget - cart.total_price; // elbdev: no shipping statements at all when nothing in the cart is shipped (e.g. event tickets only)

                if (this.freeShippingContainer) {
                  this.freeShippingContainer.hidden = onlyVirtualProducts && cart.items.length > 0;
                }

                if (this.freeShippingTextContent) {
                  if (cart.total_price < this.freeShippingTarget && freeShippingRest > 0) {
                    formattedAmount = (0,_helpers_format_money_js__WEBPACK_IMPORTED_MODULE_0__.formatMoney)(freeShippingRest, this.moneyFormat);
                    missingText = this.freeShippingContainer.getAttribute('data-missing-text').replace('[value]', formattedAmount);
                    this.freeShippingTextContent.innerHTML = missingText;
                  } else if (cart.total_price >= this.freeShippingTarget || shippingPrice === 0) {
                    goalText = this.freeShippingContainer.getAttribute('data-goal-text');
                    this.freeShippingTextContent.innerHTML = goalText;
                  }
                }

                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context["catch"](0);
                console.error('Error updating free shipping text:', _context.t0);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 19]]);
      }));

      function updateFreeShippingText() {
        return _updateFreeShippingText.apply(this, arguments);
      }

      return updateFreeShippingText;
    }()
  }, {
    key: "open",
    value: function open() {
      this.renderCartIcon();
      this.updateFreeShippingText();

      if (this.active === 'true') {
        return;
      } // if (this.isAbTestActive) {
      //     this.toCartButtons.forEach(button => button.setAttribute('href', '/cart'))
      // }


      this.active = "true";
      setTimeout(function () {
        this.classList.add('animate');
      }.bind(this));
      setTimeout(this.animate.bind(this), 400);

      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
      }

      this.closeTimeout = setTimeout(this.close.bind(this), this.duration);
    }
  }, {
    key: "close",
    value: function close() {
      if (this.closeTimeout) {
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }

      this.classList.remove('animate');
      setTimeout(function () {
        this.active = "false";
      }.bind(this), 500);
    }
  }, {
    key: "renderCartIcon",
    value: function renderCartIcon() {
      this.getCartIcon();
      var clone = this.defaultCartIcon.cloneNode(true);
      this.cartIconContainer.innerHTML = '';
      this.cartIconContainer.appendChild(clone);
    }
  }]);

  return StickyGoodChoiceBanner;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-sticky-good-choice')) {
  customElements.define('ed-sticky-good-choice', StickyGoodChoiceBanner);
}

/***/ }),

/***/ "./src/js/modules/ed-testimonials.js":
/*!*******************************************!*\
  !*** ./src/js/modules/ed-testimonials.js ***!
  \*******************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdTestimonials = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdTestimonials, _HTMLElement);

  var _super = _createSuper(EdTestimonials);

  function EdTestimonials() {
    _classCallCheck(this, EdTestimonials);

    return _super.apply(this, arguments);
  }

  _createClass(EdTestimonials, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._updateScrollBarVisibility();

      this._updateScrollProgress();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.slider = this.querySelector('.testimonial-list');
      this.scrollBar = this.querySelector('.testimonials-scroll-bar');
      this.scrollProgress = this.querySelector('.testimonials-scroll-progress');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.slider.addEventListener('scroll', function () {
        _this._updateScrollProgress();
      });
      window.addEventListener('resize', function () {
        _this._updateScrollBarVisibility();
      });
    }
  }, {
    key: "_updateScrollBarVisibility",
    value: function _updateScrollBarVisibility() {
      // Check if the slider content is overflowing its container
      if (this.slider.offsetWidth < this.slider.scrollWidth) {
        this.scrollBar.style.display = 'block';
      } else {
        this.scrollBar.style.display = 'none';
      }
    }
  }, {
    key: "_updateScrollProgress",
    value: function _updateScrollProgress() {
      // Calculate the scroll progress
      var scrolled = this.slider.scrollLeft / (this.slider.scrollWidth - this.slider.clientWidth) * 100;
      this.scrollProgress.style.width = "".concat(scrolled, "%");
    }
  }]);

  return EdTestimonials;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-testimonials')) {
  customElements.define('ed-testimonials', EdTestimonials);
}

/***/ }),

/***/ "./src/js/modules/ed-variant-legend.js":
/*!*********************************************!*\
  !*** ./src/js/modules/ed-variant-legend.js ***!
  \*********************************************/
/***/ (() => {

/*
Shows the selected value behind the option name ("Größe: 40g") on the PDP and keeps it
in sync with the size pills. The quick-buy popup re-renders server-side and needs no JS.
*/
document.addEventListener('change', function (e) {
  var _input$closest;

  var input = e.target;
  if (!input.matches('variant-radios input[type="radio"]')) return;
  var value = (_input$closest = input.closest('fieldset')) === null || _input$closest === void 0 ? void 0 : _input$closest.querySelector('[data-ed-option-value]');
  if (value) value.textContent = input.value;
});

/***/ }),

/***/ "./src/js/modules/ed-video-component.js":
/*!**********************************************!*\
  !*** ./src/js/modules/ed-video-component.js ***!
  \**********************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoThumbnail = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoThumbnail, _HTMLElement);

  var _super = _createSuper(EdVideoThumbnail);

  function EdVideoThumbnail() {
    var _this;

    _classCallCheck(this, EdVideoThumbnail);

    _this = _super.call(this); // SELECTORS

    _this.popUp = document.querySelector('.video-popup-container');
    _this.popUpVideo = _this.popUp.querySelector('.video-container'); // video inside of popup

    _this.openButton = _this.querySelector('.btn-open');
    _this.closeButton = _this.popUp.querySelector('.btn-close'); // ENABLE EXTERNAL POPUP ELEMENT

    if (_this.popUp) {
      document.querySelector('ed-video-popup').setAttribute('enabled', '');
    } // SETUP EVENT LISTENERS


    _this._attachListeners();

    return _this;
  }

  _createClass(EdVideoThumbnail, [{
    key: "videoSrc",
    get: function get() {
      return this.getAttribute('video-src');
    }
  }, {
    key: "autoPlay",
    get: function get() {
      return this.getAttribute('autoplay');
    }
  }, {
    key: "controls",
    get: function get() {
      return this.getAttribute('controls');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('keydown', this.closeOnEsc.bind(this));
      this.openButton.addEventListener('click', this.openPopup.bind(this)); // click outside

      this.popUp.addEventListener('click', this.closePopup.bind(this));
      this.closeButton.addEventListener('click', this.closePopup.bind(this));
    }
  }, {
    key: "openPopup",
    value: function openPopup(e) {
      e.stopPropagation();
      this.createVideo();
      this.popUp.classList.add('open');
      document.documentElement.classList.add('ed-video-popup-open');
    }
  }, {
    key: "closePopup",
    value: function closePopup(e) {
      e.stopPropagation();
      this.popUpVideo.innerHTML = '';
      this.popUp.classList.remove('open');
      document.documentElement.classList.remove('ed-video-popup-open');
    }
  }, {
    key: "closeOnEsc",
    value: function closeOnEsc(e) {
      if (e.key === 'Escape') {
        this.popUpVideo.innerHTML = '';
        document.documentElement.classList.remove('ed-video-popup-open');
        this.popUp.classList.remove('open');
      }
    }
  }, {
    key: "createVideo",
    value: function createVideo() {
      var video = document.createElement('video');
      video.src = this.videoSrc;
      /** settings **/

      video.autoplay = true;
      video.controls = true;

      if (this.autoPlay === 'false') {
        video.autoplay = false;
      }

      if (this.controls === 'false') {
        video.controls = false;
      }

      this.popUpVideo.appendChild(video);
    }
  }]);

  return EdVideoThumbnail;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-video-thumbnail')) {
  customElements.define('ed-video-thumbnail', EdVideoThumbnail);
}

var EdVideoPopup = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(EdVideoPopup, _HTMLElement2);

  var _super2 = _createSuper(EdVideoPopup);

  function EdVideoPopup() {
    _classCallCheck(this, EdVideoPopup);

    return _super2.call(this);
  }

  return _createClass(EdVideoPopup);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-video-popup')) {
  customElements.define('ed-video-popup', EdVideoPopup);
}

/***/ }),

/***/ "./src/js/modules/ed-video-testimonials.js":
/*!*************************************************!*\
  !*** ./src/js/modules/ed-video-testimonials.js ***!
  \*************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EdVideoTestimonials = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EdVideoTestimonials, _HTMLElement);

  var _super = _createSuper(EdVideoTestimonials);

  function EdVideoTestimonials() {
    _classCallCheck(this, EdVideoTestimonials);

    return _super.apply(this, arguments);
  }

  _createClass(EdVideoTestimonials, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._updateScrollBarVisibility();

      this._updateScrollProgress();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      this.slider = this.querySelector('.video-testimonial-list');
      this.scrollBar = this.querySelector('.video-testimonials-scroll-bar');
      this.scrollProgress = this.querySelector('.video-testimonials-scroll-progress');
      this.playButtons = this.querySelectorAll('.play-button-wrapper');
      this.videoCards = this.querySelectorAll('.video-testimonial-card');
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      var _this = this;

      this.slider.addEventListener('scroll', function () {
        _this._updateScrollProgress();
      });
      this.playButtons.forEach(function (button) {
        button.addEventListener('click', function (e) {
          _this._playVideo(e);

          e.stopPropagation();
        });
      });
      this.videoCards.forEach(function (card) {
        card.addEventListener('click', function () {
          _this._toggleVideoPlay(card);
        });
      });
      window.addEventListener('resize', function () {
        _this._updateScrollBarVisibility();
      });
    }
  }, {
    key: "_playVideo",
    value: function _playVideo(e) {
      var videoCard = e.target.closest('.video-testimonial-card');

      if (videoCard) {
        var video = videoCard.querySelector('video');
        var playButton = videoCard.querySelector('.play-button-wrapper');

        if (video) {
          video.play();
          playButton.style.display = 'none';
        }
      }
    }
  }, {
    key: "_toggleVideoPlay",
    value: function _toggleVideoPlay(card) {
      var video = card.querySelector('video');
      var playButton = card.querySelector('.play-button-wrapper');

      if (video) {
        if (!video.paused) {
          video.pause();
          playButton.style.display = 'block';
        }
      }
    }
  }, {
    key: "_updateScrollBarVisibility",
    value: function _updateScrollBarVisibility() {
      if (this.slider.offsetWidth < this.slider.scrollWidth) {
        this.scrollBar.style.display = 'block';
      } else {
        this.scrollBar.style.display = 'none';
      }
    }
  }, {
    key: "_updateScrollProgress",
    value: function _updateScrollProgress() {
      var scrolled = this.slider.scrollLeft / (this.slider.scrollWidth - this.slider.clientWidth) * 100;
      this.scrollProgress.style.width = "".concat(scrolled, "%");
    }
  }]);

  return EdVideoTestimonials;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('ed-video-testimonials')) {
  customElements.define('ed-video-testimonials', EdVideoTestimonials);
}

/***/ }),

/***/ "./src/js/modules/sticky-add-to-cart-bar.js":
/*!**************************************************!*\
  !*** ./src/js/modules/sticky-add-to-cart-bar.js ***!
  \**************************************************/
/***/ (() => {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } Object.defineProperty(subClass, "prototype", { value: Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }), writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// Breakpoint separating the mobile and desktop visibility modes. Matches the
// 768px split the rest of the sticky bar styling already uses.
var DESKTOP_MEDIA_QUERY = '(min-width: 768px)';
var DEFAULT_VISIBILITY_MODE = 'below-button';

var StickyAddToCartBar = /*#__PURE__*/function (_HTMLElement) {
  _inherits(StickyAddToCartBar, _HTMLElement);

  var _super = _createSuper(StickyAddToCartBar);

  function StickyAddToCartBar() {
    var _this;

    _classCallCheck(this, StickyAddToCartBar);

    _this = _super.call(this); // Visibility mode is configured separately per breakpoint. A single
    // `visibility-mode` attribute is still honoured as a fallback for both.

    var fallbackMode = _this.getAttribute('visibility-mode') || DEFAULT_VISIBILITY_MODE;
    _this.desktopMode = _this.getAttribute('visibility-mode-desktop') || fallbackMode;
    _this.mobileMode = _this.getAttribute('visibility-mode-mobile') || fallbackMode;
    _this.desktopMediaQuery = window.matchMedia(DESKTOP_MEDIA_QUERY);
    _this.visibilityMode = _this._resolveVisibilityMode();
    _this.lastIntersectionEntry = null;
    _this.handleVariantChanged = _this.handleVariantChanged.bind(_assertThisInitialized(_this));
    _this.handleAddToCartClick = _this.handleAddToCartClick.bind(_assertThisInitialized(_this));
    _this.handleIntersection = _this.handleIntersection.bind(_assertThisInitialized(_this));
    _this.handleBreakpointChange = _this.handleBreakpointChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(StickyAddToCartBar, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this._attachSelectors();

      this._attachListeners();

      this._initObserver();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      document.removeEventListener('variant:changed', this.handleVariantChanged);
      this.desktopMediaQuery.removeEventListener('change', this.handleBreakpointChange);

      if (this.addToCartButton) {
        this.addToCartButton.removeEventListener('click', this.handleAddToCartClick);
      }

      if (this.stickySelector) {
        this.stickySelector.removeEventListener('change', this.handleStickySelectorChange);
      }

      if (this.observer) {
        this.observer.disconnect();
      }
    }
  }, {
    key: "_resolveVisibilityMode",
    value: function _resolveVisibilityMode() {
      return this.desktopMediaQuery.matches ? this.desktopMode : this.mobileMode;
    }
  }, {
    key: "handleBreakpointChange",
    value: function handleBreakpointChange() {
      var nextMode = this._resolveVisibilityMode();

      if (nextMode === this.visibilityMode) return;
      this.visibilityMode = nextMode;

      this._recalculateVisibility();
    }
  }, {
    key: "_attachSelectors",
    value: function _attachSelectors() {
      var _this2 = this;

      this.buyButton = document.querySelector('.product-form__submit');
      this.addToCartButton = this.querySelector('.btn-atc');
      this.stickySelector = this.querySelector('#sticky-selector .select__select');
      this.stickySelectorOptions = this.querySelectorAll('#sticky-selector .select__select option');
      this.variantRadiosWrapper = document.querySelector('variant-radios .product-form__input');
      this.priceContainer = this.querySelector('.price-container');
      this.stickyWK = this.querySelector('#sticky-wk');
      this.headerWKIcon = document.querySelector('.header__icon--cart');
      this.observeTarget = document.querySelector('.product-form__submit');

      this.handleStickySelectorChange = function (event) {
        _this2._syncMainVariantSelector(event.target.value);
      };
    }
  }, {
    key: "_attachListeners",
    value: function _attachListeners() {
      document.addEventListener('variant:changed', this.handleVariantChanged);

      if (this.addToCartButton) {
        this.addToCartButton.addEventListener('click', this.handleAddToCartClick);
      }

      if (this.stickySelector) {
        this.stickySelector.addEventListener('change', this.handleStickySelectorChange);
      }

      this.desktopMediaQuery.addEventListener('change', this.handleBreakpointChange);
    }
  }, {
    key: "_initObserver",
    value: function _initObserver() {
      if (!('IntersectionObserver' in window) || !('IntersectionObserverEntry' in window) || !('intersectionRatio' in window.IntersectionObserverEntry.prototype) || !this.observeTarget) {
        return;
      }

      this.observer = new IntersectionObserver(this.handleIntersection, {
        threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1]
      });
      this.observer.observe(this.observeTarget);

      this._recalculateVisibility();
    }
  }, {
    key: "handleIntersection",
    value: function handleIntersection(entries) {
      var entry = entries[0];
      if (!entry) return;
      this.lastIntersectionEntry = entry;

      this._applyVisibilityMode(entry);
    }
  }, {
    key: "_recalculateVisibility",
    value: function _recalculateVisibility() {
      if (!this.observeTarget) return;
      var rect = this.observeTarget.getBoundingClientRect();
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
      var verticallyVisible = rect.bottom > 0 && rect.top < viewportHeight;
      var horizontallyVisible = rect.right > 0 && rect.left < viewportWidth;
      var isIntersecting = verticallyVisible && horizontallyVisible;
      var visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
      var ratio = rect.height > 0 && isIntersecting ? Math.max(0, Math.min(visibleHeight / rect.height, 1)) : 0;
      var syntheticEntry = {
        boundingClientRect: rect,
        intersectionRatio: ratio,
        isIntersecting: isIntersecting
      };
      this.lastIntersectionEntry = syntheticEntry;

      this._applyVisibilityMode(syntheticEntry);
    }
  }, {
    key: "_applyVisibilityMode",
    value: function _applyVisibilityMode(entry) {
      if (this.visibilityMode === 'not-visible') {
        this._handleNotVisibleMode(entry);

        return;
      }

      this._handleBelowButtonMode(entry);
    }
  }, {
    key: "_handleBelowButtonMode",
    value: function _handleBelowButtonMode(entry) {
      var dif = entry.boundingClientRect.top;

      if (dif < 0) {
        this.showStickyBar();
      } else {
        this.hideStickyBar();
      }
    }
  }, {
    key: "_handleNotVisibleMode",
    value: function _handleNotVisibleMode(entry) {
      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        this.hideStickyBar();
      } else {
        this.showStickyBar();
      }
    }
  }, {
    key: "handleVariantChanged",
    value: function handleVariantChanged(e) {
      var _e$detail;

      var newVariant = (_e$detail = e.detail) === null || _e$detail === void 0 ? void 0 : _e$detail.newVariant;
      if (!newVariant) return;

      this._updateStickyDropdown(newVariant);

      this._updateMainVariantSelector(newVariant);

      this._updatePrice(newVariant);
    }
  }, {
    key: "handleAddToCartClick",
    value: function handleAddToCartClick() {
      if (this.buyButton) {
        this.buyButton.click();
        this.showGuteWahl();
      }
    }
  }, {
    key: "_updateStickyDropdown",
    value: function _updateStickyDropdown(newVariant) {
      var _this3 = this;

      if (!this.stickySelector || !this.stickySelectorOptions.length) return;
      this.stickySelectorOptions.forEach(function (option) {
        if (newVariant.option1 === option.getAttribute('value')) {
          option.selected = true;
          _this3.stickySelector.value = newVariant.option1;
        } else {
          option.selected = false;
        }
      });
    }
  }, {
    key: "_updateMainVariantSelector",
    value: function _updateMainVariantSelector(newVariant) {
      if (!this.variantRadiosWrapper) return;
      var variantRadioInputs = this.variantRadiosWrapper.querySelectorAll('input');
      variantRadioInputs.forEach(function (input) {
        if (newVariant.option1 === input.getAttribute('value')) {
          if (input.nextElementSibling) {
            input.nextElementSibling.click();
          } else {
            input.click();
          }
        }
      });
    }
  }, {
    key: "_syncMainVariantSelector",
    value: function _syncMainVariantSelector(selectedValue) {
      if (!this.variantRadiosWrapper) return;
      var variantRadioInputs = this.variantRadiosWrapper.querySelectorAll('input');
      variantRadioInputs.forEach(function (input) {
        if (input.value === selectedValue || input.getAttribute('value') === selectedValue) {
          if (input.nextElementSibling) {
            input.nextElementSibling.click();
          } else {
            input.click();
          }
        }
      });
    }
  }, {
    key: "_updatePrice",
    value: function _updatePrice(newVariant) {
      if (!this.priceContainer || typeof newVariant.price === 'undefined') return;
      var newPrice = '€' + (newVariant.price / 100).toFixed(2);
      newPrice = newPrice.replace('.', ',');
      this.priceContainer.innerHTML = newPrice;
    }
  }, {
    key: "showGuteWahl",
    value: function showGuteWahl() {
      if (!this.stickyWK || !this.headerWKIcon) return;
      var clone = this.headerWKIcon.cloneNode(true);
      this.stickyWK.innerHTML = '';
      this.stickyWK.appendChild(clone);
      document.body.classList.add('show_gute_wahl');
      setTimeout(function () {
        document.body.classList.add('animate_gute_wahl');
      }, 1000);
      setTimeout(function () {
        document.body.classList.remove('animate_gute_wahl');
        setTimeout(function () {
          document.body.classList.remove('show_gute_wahl');
        }, 200);
      }, 4000);
    }
  }, {
    key: "showStickyBar",
    value: function showStickyBar() {
      if (this._isGorgiasChatOpen()) {
        this.hideStickyBar();
        return;
      }

      document.body.classList.add('animate-show_sticky_atc');
      document.body.classList.add('show_sticky_atc');
    }
  }, {
    key: "hideStickyBar",
    value: function hideStickyBar() {
      document.body.classList.remove('show_sticky_atc');
      document.body.classList.remove('animate-show_sticky_atc');
    }
  }, {
    key: "_isGorgiasChatOpen",
    value: function _isGorgiasChatOpen() {
      var chatWindowIframe = document.querySelector('#gorgias-chat-container #chat-window');
      if (!chatWindowIframe) return false;

      try {
        var _chatWindowIframe$con;

        var iframeDocument = chatWindowIframe.contentDocument || ((_chatWindowIframe$con = chatWindowIframe.contentWindow) === null || _chatWindowIframe$con === void 0 ? void 0 : _chatWindowIframe$con.document);
        var hasOpenState = !!(iframeDocument !== null && iframeDocument !== void 0 && iframeDocument.querySelector('[data-is-open="true"]'));
        if (hasOpenState) return true;
      } catch (error) {// ignore iframe access issues
      }

      var styles = window.getComputedStyle(chatWindowIframe);
      return styles.display !== 'none' && styles.visibility !== 'hidden' && chatWindowIframe.offsetWidth > 0 && chatWindowIframe.offsetHeight > 0;
    }
  }]);

  return StickyAddToCartBar;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

customElements.define('ed-sticky-add-to-cart-bar', StickyAddToCartBar);

/***/ }),

/***/ "./src/js/modules/update-total-price-cart.js":
/*!***************************************************!*\
  !*** ./src/js/modules/update-total-price-cart.js ***!
  \***************************************************/
/***/ (() => {

document.addEventListener('DOMContentLoaded', function () {
  // UPDATE TOTAL PRICE ON TOP OF CART
  if (window.location.href.includes('/cart')) {
    document.addEventListener('ed-gift-system:update', function (e) {
      var totalPrice = document.querySelector('.total-price-value');
      var cart = e.detail;
      totalPrice.innerText = formatMoney(cart.totalPrice, window.edGiftSystemSettings.moneyFormat);
    });
  }
});
/** METHODS **/

function formatMoney(cents, format) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }

  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = format || '${{amount}}';

  function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ',');
    decimal = defaultTo(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
        dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        centsAmount = parts[1] ? decimal + parts[1] : '';
    return dollarsAmount + centsAmount;
  }

  var value = '';

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;

    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;

    case 'amount_with_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;

    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, ',', '.');
      break;

    case 'amount_no_decimals_with_space_separator':
      value = formatWithDelimiters(cents, 0, ' ');
      break;

    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
  }

  if (formatString.indexOf('with_comma_separator') !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
var __webpack_exports__ = {};
/*!**************************!*\
  !*** ./src/js/custom.js ***!
  \**************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./modules/ed-video-component */ "./src/js/modules/ed-video-component.js");
/* harmony import */ var _modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_component__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _modules_ed_gift_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./modules/ed-gift-system */ "./src/js/modules/ed-gift-system.js");
/* harmony import */ var _modules_ed_gift_system__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_gift_system__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _modules_ed_sticky_good_choice__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./modules/ed-sticky-good-choice */ "./src/js/modules/ed-sticky-good-choice.js");
/* harmony import */ var _modules_ed_product_item_atc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./modules/ed-product-item-atc */ "./src/js/modules/ed-product-item-atc.js");
/* harmony import */ var _modules_ed_quick_buy_popup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./modules/ed-quick-buy-popup */ "./src/js/modules/ed-quick-buy-popup.js");
/* harmony import */ var _modules_ed_quick_buy_popup__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_quick_buy_popup__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _modules_ed_moisturizer_list__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./modules/ed-moisturizer-list */ "./src/js/modules/ed-moisturizer-list.js");
/* harmony import */ var _modules_ed_blog_filter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./modules/ed-blog-filter */ "./src/js/modules/ed-blog-filter.js");
/* harmony import */ var _modules_ed_blog_filter__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_blog_filter__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _modules_ed_testimonials__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./modules/ed-testimonials */ "./src/js/modules/ed-testimonials.js");
/* harmony import */ var _modules_ed_testimonials__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_testimonials__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _modules_ed_video_testimonials__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./modules/ed-video-testimonials */ "./src/js/modules/ed-video-testimonials.js");
/* harmony import */ var _modules_ed_video_testimonials__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_video_testimonials__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _modules_ed_product_info_banner__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./modules/ed-product-info-banner */ "./src/js/modules/ed-product-info-banner.js");
/* harmony import */ var _modules_ed_product_info_banner__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_product_info_banner__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _modules_ed_recharge_widget__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./modules/ed-recharge-widget */ "./src/js/modules/ed-recharge-widget.js");
/* harmony import */ var _modules_update_total_price_cart__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./modules/update-total-price-cart */ "./src/js/modules/update-total-price-cart.js");
/* harmony import */ var _modules_update_total_price_cart__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_modules_update_total_price_cart__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _modules_ed_cross_sell__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./modules/ed-cross-sell */ "./src/js/modules/ed-cross-sell.js");
/* harmony import */ var _modules_ed_cross_sell__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cross_sell__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _modules_ed_cart_upsells__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./modules/ed-cart-upsells */ "./src/js/modules/ed-cart-upsells.js");
/* harmony import */ var _modules_ed_cart_subscription_group__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./modules/ed-cart-subscription-group */ "./src/js/modules/ed-cart-subscription-group.js");
/* harmony import */ var _modules_ed_cart_subscription_group__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_subscription_group__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _modules_ed_dropdown__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./modules/ed-dropdown */ "./src/js/modules/ed-dropdown.js");
/* harmony import */ var _modules_ed_dropdown__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_dropdown__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _modules_ed_cart_subscription_plan__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./modules/ed-cart-subscription-plan */ "./src/js/modules/ed-cart-subscription-plan.js");
/* harmony import */ var _modules_ed_cart_subscription_plan__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_cart_subscription_plan__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _modules_ed_announcement_countdown__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./modules/ed-announcement-countdown */ "./src/js/modules/ed-announcement-countdown.js");
/* harmony import */ var _modules_ed_announcement_countdown__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_announcement_countdown__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var _modules_ed_popular_collections__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./modules/ed-popular-collections */ "./src/js/modules/ed-popular-collections.js");
/* harmony import */ var _modules_ed_popular_collections__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_popular_collections__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _modules_ed_featured_collection__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./modules/ed-featured-collection */ "./src/js/modules/ed-featured-collection.js");
/* harmony import */ var _modules_ed_featured_collection__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_featured_collection__WEBPACK_IMPORTED_MODULE_19__);
/* harmony import */ var _modules_ed_discount_collection__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./modules/ed-discount-collection */ "./src/js/modules/ed-discount-collection.js");
/* harmony import */ var _modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./modules/sticky-add-to-cart-bar */ "./src/js/modules/sticky-add-to-cart-bar.js");
/* harmony import */ var _modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(_modules_sticky_add_to_cart_bar__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _modules_ed_gwp_progress_bar__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./modules/ed-gwp-progress-bar */ "./src/js/modules/ed-gwp-progress-bar.js");
/* harmony import */ var _modules_ed_ab_sync__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./modules/ed-ab-sync */ "./src/js/modules/ed-ab-sync.js");
/* harmony import */ var _modules_ed_ab_sync__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_ab_sync__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _modules_ed_section_teaser_boxes__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./modules/ed-section-teaser-boxes */ "./src/js/modules/ed-section-teaser-boxes.js");
/* harmony import */ var _modules_ed_section_teaser_boxes__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_section_teaser_boxes__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _modules_ed_media_quote__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./modules/ed-media-quote */ "./src/js/modules/ed-media-quote.js");
/* harmony import */ var _modules_ed_media_quote__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_media_quote__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _modules_ed_shipping_note__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./modules/ed-shipping-note */ "./src/js/modules/ed-shipping-note.js");
/* harmony import */ var _modules_ed_shipping_note__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_shipping_note__WEBPACK_IMPORTED_MODULE_26__);
/* harmony import */ var _modules_ed_drag_scroll__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./modules/ed-drag-scroll */ "./src/js/modules/ed-drag-scroll.js");
/* harmony import */ var _modules_ed_variant_legend__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./modules/ed-variant-legend */ "./src/js/modules/ed-variant-legend.js");
/* harmony import */ var _modules_ed_variant_legend__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(_modules_ed_variant_legend__WEBPACK_IMPORTED_MODULE_28__);
/*
DO NOT TOUCH THIS FILE OUTSIDE OF /src DIRECTORY
this file gets compiled ./assets/custom.js - make sure to import every module here.
*/





























})();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/scss/custom.scss ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin

})();

/******/ })()
;